(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._tooltip_5svgn_1{width:260px}._popover_5svgn_5{background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);box-sizing:border-box;z-index:100}._bar_1n5dj_1{overflow:hidden}._section_1n5dj_5{position:relative}._sectionHidden_1n5dj_8{display:none!important}._sectionInheritRadius_1n5dj_11{border-radius:inherit}._valueOutside_1n5dj_15{left:calc(100% + var(--dixa-size-spacer-100));z-index:1;position:absolute}:root{--dixa-analytics-color-default-1:var(--dixa-color-purple-700);--dixa-analytics-color-default-2:var(--dixa-color-blue-300);--dixa-analytics-color-default-3:var(--dixa-color-red-500);--dixa-analytics-color-default-4:var(--dixa-color-orange-300);--dixa-analytics-color-default-5:var(--dixa-color-purple-500);--dixa-analytics-color-default-6:var(--dixa-color-green-400);--dixa-analytics-color-default-7:var(--dixa-color-neutral-600);--dixa-analytics-color-default-8:var(--dixa-color-neutral-400);--dixa-analytics-color-rating-1:var(--dixa-color-red-600);--dixa-analytics-color-rating-2:var(--dixa-color-red-400);--dixa-analytics-color-rating-3:var(--dixa-color-orange-300);--dixa-analytics-color-rating-4:var(--dixa-color-green-500);--dixa-analytics-color-rating-5:var(--dixa-color-green-600)}[data-color-mode=dark]{--dixa-analytics-color-default-1:var(--dixa-color-blue-300);--dixa-analytics-color-default-2:var(--dixa-color-blue-700);--dixa-analytics-color-default-3:var(--dixa-color-red-400);--dixa-analytics-color-default-4:var(--dixa-color-orange-600);--dixa-analytics-color-default-5:var(--dixa-color-purple-500);--dixa-analytics-color-default-6:var(--dixa-color-green-500);--dixa-analytics-color-default-7:var(--dixa-color-neutral-400);--dixa-analytics-color-default-8:var(--dixa-color-neutral-800);--dixa-analytics-color-rating-1:var(--dixa-color-red-400);--dixa-analytics-color-rating-2:var(--dixa-color-red-600);--dixa-analytics-color-rating-3:var(--dixa-color-orange-600);--dixa-analytics-color-rating-4:var(--dixa-color-green-400);--dixa-analytics-color-rating-5:var(--dixa-color-green-300)}._container_1t2a7_1{overflow:hidden}._root_6kwn9_1{column-gap:var(--dixa-size-spacer-200);row-gap:var(--dixa-size-spacer-300);white-space:nowrap;display:grid}._root_6kwn9_1:not(._rootBounded_6kwn9_7):not(._rootFluid_6kwn9_7){grid-template-columns:repeat(auto-fit, minmax(min(100% / 2 - var(--dixa-size-spacer-200) * (2 - 1) / 2, max(96px, 100% / 6 - var(--dixa-size-spacer-200) * (6 - 1) / 6)), 1fr))}._rootFluid_6kwn9_7,._rootBounded_6kwn9_7{grid-template-columns:repeat(auto-fit,minmax(96px,1fr))}._rootBounded_6kwn9_7{max-width:calc(6 * 96px + var(--dixa-size-spacer-200) * (6 - 1))}._wrapper_1w7q6_1{align-self:flex-start;display:inline-flex}._text_1w7q6_6{font-size:var(--dixa-typography-size-600)}._colorIndicator_luubh_1{border-radius:50%;flex-shrink:0;width:6px;height:6px}._root_scczo_54{gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);box-shadow:var(--dixa-effect-box-shadow-300);background-color:var(--lightningcss-light,var(--dixa-color-neutral-900))var(--lightningcss-dark,var(--dixa-color-neutral-200));flex-direction:column;display:flex}@supports not (color:light-dark(white, black)){._root_scczo_54{background-color:var(--dixa-color-neutral-900)}}._root_scczo_54{color:var(--lightningcss-light,var(--dixa-color-neutral-000))var(--lightningcss-dark,var(--dixa-typography-color-primary))}@supports not (color:light-dark(white, black)){._root_scczo_54{color:var(--dixa-color-neutral-000)}}._legendItem_15b15_54{white-space:nowrap;cursor:pointer;opacity:1;flex-shrink:0;overflow:hidden}._legendItemInactive_15b15_61{opacity:.4}._legendIcon_15b15_65{border-radius:var(--dixa-size-border-radius-50);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-sizing:border-box;flex-shrink:0;width:12px}._legendIconBar_15b15_72{height:12px}._legendIconLine_15b15_75{height:4px}._trigger_1mrk9_1{width:100%;height:100%}._cell_hfkay_1{cursor:default;opacity:1;flex-direction:column;justify-content:center;align-items:center;height:100%;transition:opacity .2s ease-in-out;display:flex}._cell_hfkay_1:hover ._cellText_hfkay_11{color:var(--dixa-typography-color-primary)}._cellDimmed_hfkay_14{opacity:var(--dixa-effect-opacity-200)}._cellContent_hfkay_18{justify-content:center;align-items:center;width:100%;height:100%;display:flex}._cellText_hfkay_11{transition:color .2s ease-in-out}._grid_1qk2p_1{grid-auto-rows:minmax(var(--dixa-size-spacer-500), 1fr);flex-grow:1;display:grid}._row_1qk2p_7{text-align:center;grid-auto-columns:1fr;grid-auto-flow:column;align-items:center;display:grid}._legend_1k9xu_54{position:relative}._trigger_1k9xu_58{position:absolute;top:-50%;right:0}._popover_1k9xu_64{width:256px;max-height:298px;padding:var(--dixa-size-spacer-300);z-index:100;box-sizing:border-box;background:var(--dixa-color-neutral-000);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);box-shadow:var(--dixa-effect-box-shadow-300);margin:0 var(--dixa-size-spacer-200);background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);overflow-y:auto}._breakdown_1k9xu_83{gap:var(--dixa-size-spacer-250);flex-direction:column;margin:0;padding:0;list-style:none;display:flex}._breakdown_1k9xu_83 li{gap:var(--dixa-size-spacer-200);grid-template-columns:1fr auto;display:grid}._breakdown_1k9xu_83 li>:first-child{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}._tooltip_h4i5v_1{max-width:300px}._trigger_h4i5v_5{opacity:0;width:100%;height:100%;position:absolute;top:0;left:0}._tableWrapper_1xmkm_1{overflow:auto}._tableWrapperEmpty_1xmkm_4{flex-grow:1}._thCell_1xmkm_8{white-space:nowrap}._tdCell_1xmkm_12{white-space:nowrap;text-overflow:ellipsis;max-width:240px;position:relative;overflow:hidden}._tooltip_1xmkm_20{max-width:300px}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Badge as e, Box as t, Button as n, ButtonGroup as r, ButtonList as i, Divider as a, EmptyState as o, FlexBox as s, HelpIcon as c, IconButton as l, Pagination as u, Table as d, Text as f, Tooltip as p } from "@dixa/lib-shared-habla";
import * as m from "react";
import { Fragment as h, cloneElement as g, createElement as _, memo as v, useCallback as y, useEffect as b, useLayoutEffect as x, useMemo as S, useRef as C, useState as w } from "react";
import { Fragment as T, jsx as E, jsxs as D } from "react/jsx-runtime";
import * as O from "react-dom";
import k from "classnames";
import { useInterval as A, useList as j, useMap as M, usePrevious as N, useUpdateEffect as ee } from "react-use";
import { Area as te, AreaChart as P, Bar as ne, BarChart as re, CartesianGrid as ie, Cell as ae, Label as oe, LabelList as se, Legend as ce, Line as le, LineChart as ue, Pie as de, PieChart as fe, ReferenceLine as pe, ResponsiveContainer as me, Sector as he, Tooltip as ge, XAxis as _e, YAxis as ve } from "recharts";
import ye from "moment-timezone";
import { colors as be, typography as xe } from "@dixa/lib-shared-tokens";
import Se from "lodash/truncate";
import Ce from "lodash/capitalize";
import we from "lodash/debounce";
import Te from "lodash/last";
import Ee from "lodash/pick";
import De from "lodash/sum";
import Oe from "lodash/isEqual";
import ke from "lodash/isNumber";
import { TagChips as Ae } from "lib-shared-tagging";
import je from "lodash/isNil";
import Me from "lodash/orderBy";
//#region \0rolldown/runtime.js
var Ne = Object.create, Pe = Object.defineProperty, Fe = Object.getOwnPropertyDescriptor, Ie = Object.getOwnPropertyNames, Le = Object.getPrototypeOf, Re = Object.prototype.hasOwnProperty, ze = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, Be = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Ve = (e, t) => {
	let n = {};
	for (var r in e) Pe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Pe(n, Symbol.toStringTag, { value: "Module" }), n;
}, He = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Ie(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Re.call(e, s) && s !== n && Pe(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Fe(t, s)) || r.enumerable
	});
	return e;
}, Ue = (e, t, n) => (n = e == null ? {} : Ne(Le(e)), He(t || !e || !e.__esModule ? Pe(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), We = (e) => Re.call(e, "module.exports") ? e["module.exports"] : He(Pe({}, "__esModule", { value: !0 }), e), Ge = Object.defineProperty, Ke = (e, t) => Ge(e, "name", {
	value: t,
	configurable: !0
}), qe = !!(typeof window < "u" && window.document && window.document.createElement);
function F(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ Ke(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
Ke(F, "composeEventHandlers");
function Je(e) {
	if (!qe) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
Ke(Je, "getOwnerWindow");
function Ye(e) {
	if (!qe) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
Ke(Ye, "getOwnerDocument");
function Xe(e, t = !1) {
	let { activeElement: n } = Ye(e);
	if (!n?.nodeName) return null;
	if (Ze(n) && n.contentDocument) return Xe(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = Ye(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
Ke(Xe, "getActiveElement");
function Ze(e) {
	return e.tagName === "IFRAME";
}
Ke(Ze, "isFrame");
//#endregion
//#region ../../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var Qe = Object.defineProperty, $e = (e, t) => Qe(e, "name", {
	value: t,
	configurable: !0
});
function et(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
$e(et, "setRef");
function tt(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = et(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : et(e[t], null);
			}
		};
	};
}
$e(tt, "composeRefs");
function nt(...e) {
	return m.useCallback(tt(...e), e);
}
$e(nt, "useComposedRefs");
//#endregion
//#region ../../../node_modules/@radix-ui/react-context/dist/index.mjs
var rt = Object.defineProperty, I = (e, t) => rt(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function it(e, t) {
	let n = m.createContext(t);
	n.displayName = e + "Context";
	let r = /* @__PURE__ */ I((e) => {
		let { children: t, ...r } = e, i = m.useMemo(() => r, Object.values(r));
		return /* @__PURE__ */ E(n.Provider, {
			value: i,
			children: t
		});
	}, "Provider");
	r.displayName = e + "Provider";
	function i(r, i = {}) {
		let { optional: a = !1 } = i, o = m.useContext(n);
		if (o) return o;
		if (t !== void 0) return t;
		if (!a) throw Error(`\`${r}\` must be used within \`${e}\``);
	}
	return I(i, "useContext"), [r, i];
}
I(it, "createContext");
// @__NO_SIDE_EFFECTS__
function at(e, t = []) {
	let n = [];
	function r(t, r) {
		let i = m.createContext(r);
		i.displayName = t + "Context";
		let a = n.length;
		n = [...n, r];
		let o = /* @__PURE__ */ I((t) => {
			let { scope: n, children: r, ...o } = t, s = n?.[e]?.[a] || i, c = m.useMemo(() => o, Object.values(o));
			return /* @__PURE__ */ E(s.Provider, {
				value: c,
				children: r
			});
		}, "Provider");
		o.displayName = t + "Provider";
		function s(n, o, s = {}) {
			let { optional: c = !1 } = s, l = o?.[e]?.[a] || i, u = m.useContext(l);
			if (u) return u;
			if (r !== void 0) return r;
			if (!c) throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return I(s, "useContext"), [o, s];
	}
	I(r, "createContext");
	let i = /* @__PURE__ */ I(() => {
		let t = n.map((e) => m.createContext(e));
		return /* @__PURE__ */ I(function(n) {
			let r = n?.[e] || t;
			return m.useMemo(() => ({ [`__scope${e}`]: {
				...n,
				[e]: r
			} }), [n, r]);
		}, "useScope");
	}, "createScope");
	return i.scopeName = e, [r, ot(i, ...t)];
}
I(at, "createContextScope");
function ot(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = /* @__PURE__ */ I(() => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ I(function(e) {
			let r = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return m.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
		}, "useComposedScopes");
	}, "createScope");
	return n.scopeName = t.scopeName, n;
}
I(ot, "composeContextScopes");
//#endregion
//#region ../../../node_modules/@radix-ui/react-slot/dist/index.mjs
var st = Object.defineProperty, L = (e, t) => st(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ct(e) {
	let t = m.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		gt(r) && typeof bt == "function" && (r = bt(r._payload)), m.Children.forEach(r, (e) => {
			if (mt(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				gt(n) && typeof bt == "function" && (n = bt(n._payload)), a = dt(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = m.cloneElement(a, void 0, s) : !o && m.Children.count(r) === 1 && m.isValidElement(r) && (a = r);
		let c = a ? pt(a) : void 0, l = nt(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? yt(e) : vt(e));
			return r;
		}
		let u = ft(i, a.props ?? {});
		return a.type !== m.Fragment && (u.ref = n ? l : c), m.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
L(ct, "createSlot");
var lt = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function ut(e) {
	let t = /* @__PURE__ */ L((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = lt, t;
}
L(ut, "createSlottable");
var dt = /* @__PURE__ */ L((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return m.isValidElement(t) ? m.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return m.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function ft(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
L(ft, "mergeProps");
function pt(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
L(pt, "getElementRef");
function mt(e) {
	return m.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === lt;
}
L(mt, "isSlottable");
var ht = Symbol.for("react.lazy");
function gt(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === ht && "_payload" in e && _t(e._payload);
}
L(gt, "isLazyComponent");
function _t(e) {
	return typeof e == "object" && !!e && "then" in e;
}
L(_t, "isPromiseLike");
var vt = /* @__PURE__ */ L((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), yt = /* @__PURE__ */ L((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), bt = m.use, xt = Object.defineProperty, St = (e, t) => xt(e, "name", {
	value: t,
	configurable: !0
}), Ct = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ ct(`Primitive.${t}`), r = m.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ E(o, {
			...a,
			ref: r
		});
	});
	return r.displayName = `Primitive.${t}`, {
		...e,
		[t]: r
	};
}, {});
function wt(e, t) {
	e && O.flushSync(() => e.dispatchEvent(t));
}
St(wt, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var Tt = Object.defineProperty, Et = (e, t) => Tt(e, "name", {
	value: t,
	configurable: !0
});
function Dt(e) {
	let t = m.useRef(e);
	return m.useEffect(() => {
		t.current = e;
	}), m.useMemo(() => ((...e) => t.current?.(...e)), []);
}
Et(Dt, "useCallbackRef");
//#endregion
//#region ../../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var Ot = Object.defineProperty, R = (e, t) => Ot(e, "name", {
	value: t,
	configurable: !0
}), kt = "dismissableLayer.update", At = "dismissableLayer.pointerDownOutside", jt = "dismissableLayer.focusOutside", Mt, Nt = m.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), Pt = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ R(function(e, t) {
	let { disableOutsidePointerEvents: n = !1, deferPointerDownOutside: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = e, u = m.useContext(Nt), [d, f] = m.useState(null), p = d?.ownerDocument ?? globalThis?.document, [, h] = m.useState({}), g = nt(t, f), _ = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), y = v ? _.indexOf(v) : -1, b = d ? _.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, S = b >= y, C = m.useRef(!1), w = Lt((e) => {
		a?.(e), s?.(e), e.defaultPrevented || c?.();
	}, {
		ownerDocument: p,
		deferPointerDownOutside: r,
		isDeferredPointerDownOutsideRef: C,
		dismissableSurfaces: u.dismissableSurfaces,
		shouldHandlePointerDownOutside: m.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...u.branches].some((t) => t.contains(e));
			return S && !t;
		}, [u.branches, S])
	}), T = Rt((e) => {
		if (r && C.current) return;
		let t = e.target;
		[...u.branches].some((e) => e.contains(t)) || (o?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p), D = d ? b === _.length - 1 : !1, O = Dt((e) => {
		e.key === "Escape" && (i?.(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
	});
	return m.useEffect(() => {
		if (D) return p.addEventListener("keydown", O, { capture: !0 }), () => p.removeEventListener("keydown", O, { capture: !0 });
	}, [
		p,
		D,
		O
	]), m.useEffect(() => {
		if (d) return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Mt = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), zt(), () => {
			n && (u.layersWithOutsidePointerEventsDisabled.delete(d), u.layersWithOutsidePointerEventsDisabled.size === 0 && (p.body.style.pointerEvents = Mt));
		};
	}, [
		d,
		p,
		n,
		u
	]), m.useEffect(() => () => {
		d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), zt());
	}, [d, u]), m.useEffect(() => {
		let e = /* @__PURE__ */ R(() => h({}), "handleUpdate");
		return document.addEventListener(kt, e), () => document.removeEventListener(kt, e);
	}, []), /* @__PURE__ */ E(Ct.div, {
		...l,
		ref: g,
		style: {
			pointerEvents: x ? S ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: F(e.onFocusCapture, T.onFocusCapture),
		onBlurCapture: F(e.onBlurCapture, T.onBlurCapture),
		onPointerDownCapture: F(e.onPointerDownCapture, w.onPointerDownCapture)
	});
}, "DismissableLayer"));
function Ft() {
	let e = m.useContext(Nt), [t, n] = m.useState(null);
	return m.useEffect(() => {
		if (t) return e.dismissableSurfaces.add(t), () => {
			e.dismissableSurfaces.delete(t);
		};
	}, [t, e.dismissableSurfaces]), n;
}
R(Ft, "useDismissableLayerSurface");
var It = /* @__PURE__ */ R(() => !0, "IS_TRUE");
function Lt(e, t) {
	let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: r = !1, isDeferredPointerDownOutsideRef: i, dismissableSurfaces: a, shouldHandlePointerDownOutside: o = It } = t, s = Dt(e), c = m.useRef(!1), l = m.useRef(!1), u = m.useRef(/* @__PURE__ */ new Map()), d = m.useRef(() => {});
	return m.useEffect(() => {
		function e() {
			l.current = !1, i.current = !1, u.current.clear();
		}
		R(e, "resetOutsideInteraction");
		function t() {
			return Array.from(u.current.values()).some(Boolean);
		}
		R(t, "isOutsideInteractionIntercepted");
		function f(e) {
			if (!l.current) return;
			let t = e.target;
			t instanceof Node && [...a].some((e) => e.contains(t)) || u.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				l.current && d.current();
			}, 0);
		}
		R(f, "handleInteractionCapture");
		function p(e) {
			l.current && u.current.set(e.type, !1);
		}
		R(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ R((a) => {
			if (a.target && !c.current) {
				let f = function() {
					n.removeEventListener("click", d.current);
					let r = t();
					e(), r || Bt(At, s, p, { discrete: !0 });
				};
				if (R(f, "handleAndDispatchPointerDownOutsideEvent"), !o(a.target)) {
					n.removeEventListener("click", d.current), e(), c.current = !1;
					return;
				}
				let p = { originalEvent: a };
				l.current = !0, i.current = r && a.button === 0, u.current.clear(), !r || a.button !== 0 ? f() : (n.removeEventListener("click", d.current), d.current = f, n.addEventListener("click", d.current, { once: !0 }));
			} else n.removeEventListener("click", d.current), e();
			c.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) n.addEventListener(e, f, !0), n.addEventListener(e, p);
		let g = window.setTimeout(() => {
			n.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), n.removeEventListener("pointerdown", m), n.removeEventListener("click", d.current);
			for (let e of h) n.removeEventListener(e, f, !0), n.removeEventListener(e, p);
		};
	}, [
		n,
		s,
		r,
		i,
		a,
		o
	]), { onPointerDownCapture: /* @__PURE__ */ R(() => c.current = !0, "onPointerDownCapture") };
}
R(Lt, "usePointerDownOutside");
function Rt(e, t = globalThis?.document) {
	let n = Dt(e), r = m.useRef(!1);
	return m.useEffect(() => {
		let e = /* @__PURE__ */ R((e) => {
			e.target && !r.current && Bt(jt, n, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: /* @__PURE__ */ R(() => r.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ R(() => r.current = !1, "onBlurCapture")
	};
}
R(Rt, "useFocusOutside");
function zt() {
	let e = new CustomEvent(kt);
	document.dispatchEvent(e);
}
R(zt, "dispatchUpdate");
function Bt(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? wt(i, a) : i.dispatchEvent(a);
}
R(Bt, "handleAndDispatchCustomEvent");
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var Vt = Object.defineProperty, Ht = (e, t) => Vt(e, "name", {
	value: t,
	configurable: !0
}), Ut = 0, Wt = null;
function Gt(e) {
	return Kt(), e.children;
}
Ht(Gt, "FocusGuards");
function Kt() {
	m.useEffect(() => {
		Wt ||= {
			start: qt(),
			end: qt()
		};
		let { start: e, end: t } = Wt;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), Ut++, () => {
			Ut === 1 && (Wt?.start.remove(), Wt?.end.remove(), Wt = null), Ut = Math.max(0, Ut - 1);
		};
	}, []);
}
Ht(Kt, "useFocusGuards");
function qt() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Ht(qt, "createFocusGuard");
//#endregion
//#region ../../../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var Jt = Object.defineProperty, z = (e, t) => Jt(e, "name", {
	value: t,
	configurable: !0
}), Yt = "focusScope.autoFocusOnMount", Xt = "focusScope.autoFocusOnUnmount", Zt = {
	bubbles: !1,
	cancelable: !0
}, Qt = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ z(function(e, t) {
	let { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = e, [s, c] = m.useState(null), l = Dt(i), u = Dt(a), d = m.useRef(null), f = nt(t, c), p = m.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	m.useEffect(() => {
		if (r) {
			let e = function(e) {
				if (p.paused || !s) return;
				let t = e.target;
				s.contains(t) ? d.current = t : B(d.current, { select: !0 });
			}, t = function(e) {
				if (p.paused || !s) return;
				let t = e.relatedTarget;
				t !== null && (s.contains(t) || B(d.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && B(s);
			};
			z(e, "handleFocusIn"), z(t, "handleFocusOut"), z(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return s && r.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		r,
		s,
		p.paused
	]), m.useEffect(() => {
		if (s) {
			on.add(p);
			let e = document.activeElement;
			if (!s.contains(e)) {
				let t = new CustomEvent(Yt, Zt);
				s.addEventListener(Yt, l), s.dispatchEvent(t), t.defaultPrevented || ($t(ln(tn(s)), { select: !0 }), document.activeElement === e && B(s));
			}
			return () => {
				s.removeEventListener(Yt, l), setTimeout(() => {
					let t = new CustomEvent(Xt, Zt);
					s.addEventListener(Xt, u), s.dispatchEvent(t), t.defaultPrevented || B(e ?? document.body, { select: !0 }), s.removeEventListener(Xt, u), on.remove(p);
				}, 0);
			};
		}
	}, [
		s,
		l,
		u,
		p
	]);
	let h = m.useCallback((e) => {
		if (!n && !r || p.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, i = document.activeElement;
		if (t && i) {
			let t = e.currentTarget, [r, a] = en(t);
			r && a ? !e.shiftKey && i === a ? (e.preventDefault(), n && B(r, { select: !0 })) : e.shiftKey && i === r && (e.preventDefault(), n && B(a, { select: !0 })) : i === t && e.preventDefault();
		}
	}, [
		n,
		r,
		p.paused
	]);
	return /* @__PURE__ */ E(Ct.div, {
		tabIndex: -1,
		...o,
		ref: f,
		onKeyDown: h
	});
}, "FocusScope"));
function $t(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (B(r, { select: t }), document.activeElement !== n) return;
}
z($t, "focusFirst");
function en(e) {
	let t = tn(e);
	return [nn(t, e), nn(t.reverse(), e)];
}
z(en, "getTabbableEdges");
function tn(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ z((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
z(tn, "getTabbableCandidates");
function nn(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : rn(r, { upTo: t }))) return r;
}
z(nn, "findVisible");
function rn(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
z(rn, "isHidden");
function an(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
z(an, "isSelectableInput");
function B(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && an(e) && t && e.select();
	}
}
z(B, "focus");
var on = sn();
function sn() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = cn(e, t), e.unshift(t);
		},
		remove(t) {
			e = cn(e, t), e[0]?.resume();
		}
	};
}
z(sn, "createFocusScopesStack");
function cn(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
z(cn, "arrayRemove");
function ln(e) {
	return e.filter((e) => e.tagName !== "A");
}
z(ln, "removeLinks");
//#endregion
//#region ../../../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var V = globalThis?.document ? m.useLayoutEffect : () => {}, un = Object.defineProperty, dn = (e, t) => un(e, "name", {
	value: t,
	configurable: !0
}), fn = m.useId || (() => void 0), pn = 0;
function mn(e) {
	let [t, n] = m.useState(fn());
	return V(() => {
		e || n((e) => e ?? String(pn++));
	}, [e]), e || (t ? `radix-${t}` : "");
}
dn(mn, "useId");
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var hn = [
	"top",
	"right",
	"bottom",
	"left"
], gn = Math.min, H = Math.max, _n = Math.round, vn = Math.floor, yn = (e) => ({
	x: e,
	y: e
}), bn = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, xn = {
	start: "end",
	end: "start"
};
function Sn(e, t, n) {
	return H(e, gn(t, n));
}
function U(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function W(e) {
	return e.split("-")[0];
}
function Cn(e) {
	return e.split("-")[1];
}
function wn(e) {
	return e === "x" ? "y" : "x";
}
function Tn(e) {
	return e === "y" ? "height" : "width";
}
function En(e) {
	return ["top", "bottom"].includes(W(e)) ? "y" : "x";
}
function Dn(e) {
	return wn(En(e));
}
function On(e, t, n) {
	n === void 0 && (n = !1);
	let r = Cn(e), i = Dn(e), a = Tn(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = Nn(o)), [o, Nn(o)];
}
function kn(e) {
	let t = Nn(e);
	return [
		An(e),
		t,
		An(t)
	];
}
function An(e) {
	return e.replace(/start|end/g, (e) => xn[e]);
}
function jn(e, t, n) {
	let r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
	switch (e) {
		case "top":
		case "bottom": return n ? t ? i : r : t ? r : i;
		case "left":
		case "right": return t ? a : o;
		default: return [];
	}
}
function Mn(e, t, n, r) {
	let i = Cn(e), a = jn(W(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(An)))), a;
}
function Nn(e) {
	return e.replace(/left|right|bottom|top/g, (e) => bn[e]);
}
function Pn(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function Fn(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Pn(e);
}
function In(e) {
	return {
		...e,
		top: e.y,
		left: e.x,
		right: e.x + e.width,
		bottom: e.y + e.height
	};
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Ln(e, t, n) {
	let { reference: r, floating: i } = e, a = En(t), o = Dn(t), s = Tn(o), c = W(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (Cn(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
var Rn = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Ln(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		if (u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50) {
			m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
				reference: e,
				floating: t,
				strategy: i
			}) : y.rects), {x: u, y: d} = Ln(l, f, c)), n = -1;
			continue;
		}
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function zn(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = U(t, e), p = Fn(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = In(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		...a.floating,
		x: n,
		y: r
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = In(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Bn = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s } = t, { element: c, padding: l = 0 } = U(e, t) || {};
		if (c == null) return {};
		let u = Fn(l), d = {
			x: n,
			y: r
		}, f = Dn(i), p = Tn(f), m = await o.getDimensions(c), h = f === "y", g = h ? "top" : "left", _ = h ? "bottom" : "right", v = h ? "clientHeight" : "clientWidth", y = a.reference[p] + a.reference[f] - d[f] - a.floating[p], b = d[f] - a.reference[f], x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c)), S = x ? x[v] : 0;
		(!S || !await (o.isElement == null ? void 0 : o.isElement(x))) && (S = s.floating[v] || a.floating[p]);
		let C = y / 2 - b / 2, w = S / 2 - m[p] / 2 - 1, T = gn(u[g], w), E = gn(u[_], w), D = T, O = S - m[p] - E, k = S / 2 - m[p] / 2 + C, A = Sn(D, k, O), j = Cn(i) != null && k != A && a.reference[p] / 2 - (k < D ? T : E) - m[p] / 2 < 0 ? k < D ? D - k : O - k : 0;
		return {
			[f]: d[f] - j,
			data: {
				[f]: A,
				centerOffset: k - A + j
			}
		};
	}
}), Vn = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			let { placement: n, middlewareData: r, rects: i, initialPlacement: a, platform: o, elements: s } = t, { mainAxis: c = !0, crossAxis: l = !0, fallbackPlacements: u, fallbackStrategy: d = "bestFit", fallbackAxisSideDirection: f = "none", flipAlignment: p = !0, ...m } = U(e, t), h = W(n), g = W(a) === a, _ = await (o.isRTL == null ? void 0 : o.isRTL(s.floating)), v = u || (g || !p ? [Nn(a)] : kn(a));
			!u && f !== "none" && v.push(...Mn(a, p, f, _));
			let y = [a, ...v], b = await zn(t, m), x = [], S = r.flip?.overflows || [];
			if (c && x.push(b[h]), l) {
				let e = On(n, i, _);
				x.push(b[e[0]], b[e[1]]);
			}
			if (S = [...S, {
				placement: n,
				overflows: x
			}], !x.every((e) => e <= 0)) {
				let e = (r.flip?.index || 0) + 1, t = y[e];
				if (t) return {
					data: {
						index: e,
						overflows: S
					},
					reset: { placement: t }
				};
				let i = S.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!i) switch (d) {
					case "bestFit": {
						let e = S.map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (i = e);
						break;
					}
					case "initialPlacement":
						i = a;
						break;
				}
				if (n !== i) return { reset: { placement: i } };
			}
			return {};
		}
	};
};
function Hn(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Un(e) {
	return hn.some((t) => e[t] >= 0);
}
var Wn = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = U(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = Hn(await zn(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Un(e)
					} };
				}
				case "escaped": {
					let e = Hn(await zn(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Un(e)
					} };
				}
				default: return {};
			}
		}
	};
};
async function Gn(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = W(n), s = Cn(n), c = En(n) === "y", l = ["left", "top"].includes(o) ? -1 : 1, u = a && c ? -1 : 1, d = U(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: 0,
		crossAxis: 0,
		alignmentAxis: null,
		...d
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Kn = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			let { x: n, y: r } = t, i = await Gn(t, e);
			return {
				x: n + i.x,
				y: r + i.y,
				data: i
			};
		}
	};
}, qn = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = U(e, t), l = {
				x: n,
				y: r
			}, u = await zn(t, c), d = En(W(i)), f = wn(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = Sn(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = Sn(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r
				}
			};
		}
	};
}, Jn = function(e) {
	return e === void 0 && (e = {}), {
		options: e,
		fn(t) {
			let { x: n, y: r, placement: i, rects: a, middlewareData: o } = t, { offset: s = 0, mainAxis: c = !0, crossAxis: l = !0 } = U(e, t), u = {
				x: n,
				y: r
			}, d = En(i), f = wn(d), p = u[f], m = u[d], h = U(s, t), g = typeof h == "number" ? {
				mainAxis: h,
				crossAxis: 0
			} : {
				mainAxis: 0,
				crossAxis: 0,
				...h
			};
			if (c) {
				let e = f === "y" ? "height" : "width", t = a.reference[f] - a.floating[e] + g.mainAxis, n = a.reference[f] + a.reference[e] - g.mainAxis;
				p < t ? p = t : p > n && (p = n);
			}
			if (l) {
				let e = f === "y" ? "width" : "height", t = ["top", "left"].includes(W(i)), n = a.reference[d] - a.floating[e] + (t && o.offset?.[d] || 0) + (t ? 0 : g.crossAxis), r = a.reference[d] + a.reference[e] + (t ? 0 : o.offset?.[d] || 0) - (t ? g.crossAxis : 0);
				m < n ? m = n : m > r && (m = r);
			}
			return {
				[f]: p,
				[d]: m
			};
		}
	};
}, Yn = function(e) {
	return e === void 0 && (e = {}), {
		name: "size",
		options: e,
		async fn(t) {
			let { placement: n, rects: r, platform: i, elements: a } = t, { apply: o = () => {}, ...s } = U(e, t), c = await zn(t, s), l = W(n), u = Cn(n), d = En(n) === "y", { width: f, height: p } = r.floating, m, h;
			l === "top" || l === "bottom" ? (m = l, h = u === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (h = l, m = u === "end" ? "top" : "bottom");
			let g = p - c[m], _ = f - c[h], v = !t.middlewareData.shift, y = g, b = _;
			if (d) {
				let e = f - c.left - c.right;
				b = u || v ? gn(_, e) : e;
			} else {
				let e = p - c.top - c.bottom;
				y = u || v ? gn(g, e) : e;
			}
			if (v && !u) {
				let e = H(c.left, 0), t = H(c.right, 0), n = H(c.top, 0), r = H(c.bottom, 0);
				d ? b = f - 2 * (e !== 0 || t !== 0 ? e + t : H(c.left, c.right)) : y = p - 2 * (n !== 0 || r !== 0 ? n + r : H(c.top, c.bottom));
			}
			await o({
				...t,
				availableWidth: b,
				availableHeight: y
			});
			let x = await i.getDimensions(a.floating);
			return f !== x.width || p !== x.height ? { reset: { rects: !0 } } : {};
		}
	};
};
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@floating-ui/utils/dom/dist/floating-ui.utils.dom.mjs
function Xn(e) {
	return Zn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function G(e) {
	return e?.ownerDocument?.defaultView || window;
}
function K(e) {
	return ((Zn(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Zn(e) {
	return e instanceof Node || e instanceof G(e).Node;
}
function q(e) {
	return e instanceof Element || e instanceof G(e).Element;
}
function J(e) {
	return e instanceof HTMLElement || e instanceof G(e).HTMLElement;
}
function Qn(e) {
	return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof G(e).ShadowRoot;
}
function $n(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Y(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function er(e) {
	return [
		"table",
		"td",
		"th"
	].includes(Xn(e));
}
function tr(e) {
	let t = rr(), n = Y(e);
	return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || [
		"transform",
		"perspective",
		"filter"
	].some((e) => (n.willChange || "").includes(e)) || [
		"paint",
		"layout",
		"strict",
		"content"
	].some((e) => (n.contain || "").includes(e));
}
function nr(e) {
	let t = or(e);
	for (; J(t) && !ir(t);) if (tr(t)) return t;
	else t = or(t);
	return null;
}
function rr() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ir(e) {
	return [
		"html",
		"body",
		"#document"
	].includes(Xn(e));
}
function Y(e) {
	return G(e).getComputedStyle(e);
}
function ar(e) {
	return q(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.pageXOffset,
		scrollTop: e.pageYOffset
	};
}
function or(e) {
	if (Xn(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Qn(e) && e.host || K(e);
	return Qn(t) ? t.host : t;
}
function sr(e) {
	let t = or(e);
	return ir(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : J(t) && $n(t) ? t : sr(t);
}
function cr(e, t) {
	t === void 0 && (t = []);
	let n = sr(e), r = n === e.ownerDocument?.body, i = G(n);
	return r ? t.concat(i, i.visualViewport || [], $n(n) ? n : []) : t.concat(n, cr(n));
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function lr(e) {
	let t = Y(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = J(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = _n(n) !== a || _n(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function ur(e) {
	return q(e) ? e : e.contextElement;
}
function dr(e) {
	let t = ur(e);
	if (!J(t)) return yn(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = lr(t), o = (a ? _n(n.width) : n.width) / r, s = (a ? _n(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var fr = /*#__PURE__*/ yn(0);
function pr(e) {
	let t = G(e);
	return !rr() || !t.visualViewport ? fr : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function mr(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== G(e) ? !1 : t;
}
function hr(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = ur(e), o = yn(1);
	t && (r ? q(r) && (o = dr(r)) : o = dr(e));
	let s = mr(a, n, r) ? pr(a) : yn(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = G(a), t = r && q(r) ? G(r) : r, n = e.frameElement;
		for (; n && r && t !== e;) {
			let e = dr(n), t = n.getBoundingClientRect(), r = Y(n), i = t.left + (n.clientLeft + parseFloat(r.paddingLeft)) * e.x, a = t.top + (n.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += i, l += a, n = G(n).frameElement;
		}
	}
	return In({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function gr(e) {
	let { rect: t, offsetParent: n, strategy: r } = e, i = J(n), a = K(n);
	if (n === a) return t;
	let o = {
		scrollLeft: 0,
		scrollTop: 0
	}, s = yn(1), c = yn(0);
	if ((i || !i && r !== "fixed") && ((Xn(n) !== "body" || $n(a)) && (o = ar(n)), J(n))) {
		let e = hr(n);
		s = dr(n), c.x = e.x + n.clientLeft, c.y = e.y + n.clientTop;
	}
	return {
		width: t.width * s.x,
		height: t.height * s.y,
		x: t.x * s.x - o.scrollLeft * s.x + c.x,
		y: t.y * s.y - o.scrollTop * s.y + c.y
	};
}
function _r(e) {
	return Array.from(e.getClientRects());
}
function vr(e) {
	return hr(K(e)).left + ar(e).scrollLeft;
}
function yr(e) {
	let t = K(e), n = ar(e), r = e.ownerDocument.body, i = H(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = H(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + vr(e), s = -n.scrollTop;
	return Y(r).direction === "rtl" && (o += H(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
function br(e, t) {
	let n = G(e), r = K(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = rr();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
function xr(e, t) {
	let n = hr(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = J(e) ? dr(e) : yn(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Sr(e, t, n) {
	let r;
	if (t === "viewport") r = br(e, n);
	else if (t === "document") r = yr(K(e));
	else if (q(t)) r = xr(t, n);
	else {
		let n = pr(e);
		r = {
			...t,
			x: t.x - n.x,
			y: t.y - n.y
		};
	}
	return In(r);
}
function Cr(e, t) {
	let n = or(e);
	return n === t || !q(n) || ir(n) ? !1 : Y(n).position === "fixed" || Cr(n, t);
}
function wr(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = cr(e).filter((e) => q(e) && Xn(e) !== "body"), i = null, a = Y(e).position === "fixed", o = a ? or(e) : e;
	for (; q(o) && !ir(o);) {
		let t = Y(o), n = tr(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && ["absolute", "fixed"].includes(i.position) || $n(o) && !n && Cr(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = or(o);
	}
	return t.set(e, r), r;
}
function Tr(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? wr(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = Sr(t, n, i);
		return e.top = H(r.top, e.top), e.right = gn(r.right, e.right), e.bottom = gn(r.bottom, e.bottom), e.left = H(r.left, e.left), e;
	}, Sr(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function Er(e) {
	return lr(e);
}
function Dr(e, t, n) {
	let r = J(t), i = K(t), a = n === "fixed", o = hr(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = yn(0);
	if (r || !r && !a) if ((Xn(t) !== "body" || $n(i)) && (s = ar(t)), r) {
		let e = hr(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && (c.x = vr(i));
	return {
		x: o.left + s.scrollLeft - c.x,
		y: o.top + s.scrollTop - c.y,
		width: o.width,
		height: o.height
	};
}
function Or(e, t) {
	return !J(e) || Y(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function kr(e, t) {
	let n = G(e);
	if (!J(e)) return n;
	let r = Or(e, t);
	for (; r && er(r) && Y(r).position === "static";) r = Or(r, t);
	return r && (Xn(r) === "html" || Xn(r) === "body" && Y(r).position === "static" && !tr(r)) ? n : r || nr(e) || n;
}
var Ar = async function(e) {
	let { reference: t, floating: n, strategy: r } = e, i = this.getOffsetParent || kr, a = this.getDimensions;
	return {
		reference: Dr(t, await i(n), r),
		floating: {
			x: 0,
			y: 0,
			...await a(n)
		}
	};
};
function jr(e) {
	return Y(e).direction === "rtl";
}
var Mr = {
	convertOffsetParentRelativeRectToViewportRelativeRect: gr,
	getDocumentElement: K,
	getClippingRect: Tr,
	getOffsetParent: kr,
	getElementRects: Ar,
	getClientRects: _r,
	getDimensions: Er,
	getScale: dr,
	isElement: q,
	isRTL: jr
};
function Nr(e, t) {
	let n = null, r, i = K(e);
	function a() {
		clearTimeout(r), n && n.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let { left: l, top: u, width: d, height: f } = e.getBoundingClientRect();
		if (s || t(), !d || !f) return;
		let p = vn(u), m = vn(i.clientWidth - (l + d)), h = vn(i.clientHeight - (u + f)), g = vn(l), _ = {
			rootMargin: -p + "px " + -m + "px " + -h + "px " + -g + "px",
			threshold: H(0, gn(1, c)) || 1
		}, v = !0;
		function y(e) {
			let t = e[0].intersectionRatio;
			if (t !== c) {
				if (!v) return o();
				t ? o(!1, t) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 100);
			}
			v = !1;
		}
		try {
			n = new IntersectionObserver(y, {
				..._,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(y, _);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function Pr(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = ur(e), u = i || a ? [...l ? cr(l) : [], ...cr(t)] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? Nr(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			p && p.observe(t);
		})), n();
	}), l && !c && p.observe(l), p.observe(t));
	let m, h = c ? hr(e) : null;
	c && g();
	function g() {
		let t = hr(e);
		h && (t.x !== h.x || t.y !== h.y || t.width !== h.width || t.height !== h.height) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d && d(), p && p.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Fr = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: Mr,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return Rn(e, t, {
		...i,
		platform: a
	});
}, Ir = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : Bn({
				element: r.current,
				padding: i
			}).fn(n) : r ? Bn({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, Lr = typeof document < "u" ? x : b;
function Rr(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n != t.length) return !1;
			for (r = n; r-- !== 0;) if (!Rr(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !Rr(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function zr(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Br(e, t) {
	let n = zr(e);
	return Math.round(t * n) / n;
}
function Vr(e) {
	let t = m.useRef(e);
	return Lr(() => {
		t.current = e;
	}), t;
}
function Hr(e) {
	e === void 0 && (e = {});
	let { placement: t = "bottom", strategy: n = "absolute", middleware: r = [], platform: i, elements: { reference: a, floating: o } = {}, transform: s = !0, whileElementsMounted: c, open: l } = e, [u, d] = m.useState({
		x: 0,
		y: 0,
		strategy: n,
		placement: t,
		middlewareData: {},
		isPositioned: !1
	}), [f, p] = m.useState(r);
	Rr(f, r) || p(r);
	let [h, g] = m.useState(null), [_, v] = m.useState(null), y = m.useCallback((e) => {
		e != C.current && (C.current = e, g(e));
	}, [g]), b = m.useCallback((e) => {
		e !== w.current && (w.current = e, v(e));
	}, [v]), x = a || h, S = o || _, C = m.useRef(null), w = m.useRef(null), T = m.useRef(u), E = Vr(c), D = Vr(i), k = m.useCallback(() => {
		if (!C.current || !w.current) return;
		let e = {
			placement: t,
			strategy: n,
			middleware: f
		};
		D.current && (e.platform = D.current), Fr(C.current, w.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: !0
			};
			A.current && !Rr(T.current, t) && (T.current = t, O.flushSync(() => {
				d(t);
			}));
		});
	}, [
		f,
		t,
		n,
		D
	]);
	Lr(() => {
		l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, d((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [l]);
	let A = m.useRef(!1);
	Lr(() => (A.current = !0, () => {
		A.current = !1;
	}), []), Lr(() => {
		if (x && (C.current = x), S && (w.current = S), x && S) {
			if (E.current) return E.current(x, S, k);
			k();
		}
	}, [
		x,
		S,
		k,
		E
	]);
	let j = m.useMemo(() => ({
		reference: C,
		floating: w,
		setReference: y,
		setFloating: b
	}), [y, b]), M = m.useMemo(() => ({
		reference: x,
		floating: S
	}), [x, S]), N = m.useMemo(() => {
		let e = {
			position: n,
			left: 0,
			top: 0
		};
		if (!M.floating) return e;
		let t = Br(M.floating, u.x), r = Br(M.floating, u.y);
		return s ? {
			...e,
			transform: "translate(" + t + "px, " + r + "px)",
			...zr(M.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: n,
			left: t,
			top: r
		};
	}, [
		n,
		s,
		M.floating,
		u.x,
		u.y
	]);
	return m.useMemo(() => ({
		...u,
		update: k,
		refs: j,
		elements: M,
		floatingStyles: N
	}), [
		u,
		k,
		j,
		M,
		N
	]);
}
//#endregion
//#region ../../../node_modules/@radix-ui/react-use-size/dist/index.mjs
var Ur = Object.defineProperty, Wr = (e, t) => Ur(e, "name", {
	value: t,
	configurable: !0
});
function Gr(e) {
	let [t, n] = m.useState(void 0);
	return V(() => {
		if (e) {
			n({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let r = t[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				n({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		} else n(void 0);
	}, [e]), t;
}
Wr(Gr, "useSize");
//#endregion
//#region ../../../node_modules/@radix-ui/react-popper/dist/index.mjs
var Kr = Object.defineProperty, X = (e, t) => Kr(e, "name", {
	value: t,
	configurable: !0
}), qr = "Popper", [Jr, Yr] = /* @__PURE__ */ at(qr), [Xr, Zr] = Jr(qr), Qr = /* @__PURE__ */ X((e) => {
	let { __scopePopper: t, children: n } = e, [r, i] = m.useState(null), [a, o] = m.useState(void 0);
	return /* @__PURE__ */ E(Xr, {
		scope: t,
		anchor: r,
		onAnchorChange: i,
		placementState: a,
		setPlacementState: o,
		children: n
	});
}, "Popper"), $r = "PopperAnchor", ei = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { __scopePopper: n, virtualRef: r, ...i } = e, a = Zr($r, n), o = m.useRef(null), s = a.onAnchorChange, c = nt(t, m.useCallback((e) => {
		o.current = e, e && s(e);
	}, [s])), l = m.useRef(null);
	m.useEffect(() => {
		if (!r) return;
		let e = l.current;
		l.current = r.current, e !== l.current && s(l.current);
	});
	let u = a.placementState && si(a.placementState), d = u?.[0], f = u?.[1];
	return r ? null : /* @__PURE__ */ E(Ct.div, {
		"data-radix-popper-side": d,
		"data-radix-popper-align": f,
		...i,
		ref: c
	});
}, "PopperAnchor")), ti = "PopperContent", [ni, ri] = Jr(ti), ii = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ X(function(e, t) {
	let { __scopePopper: n, side: r = "bottom", sideOffset: i = 0, align: a = "center", alignOffset: o = 0, arrowPadding: s = 0, avoidCollisions: c = !0, collisionBoundary: l = [], collisionPadding: u = 0, sticky: d = "partial", hideWhenDetached: f = !1, updatePositionStrategy: p = "optimized", onPlaced: h, ...g } = e, _ = Zr(ti, n), [v, y] = m.useState(null), b = nt(t, y), [x, S] = m.useState(null), C = Gr(x), w = C?.width ?? 0, T = C?.height ?? 0, D = r + (a === "center" ? "" : "-" + a), O = typeof u == "number" ? u : {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...u
	}, k = Array.isArray(l) ? l : [l], A = k.length > 0, j = {
		padding: O,
		boundary: k.filter(ai),
		altBoundary: A
	}, { refs: M, floatingStyles: N, placement: ee, isPositioned: te, middlewareData: P } = Hr({
		strategy: "fixed",
		placement: D,
		whileElementsMounted: /* @__PURE__ */ X((...e) => Pr(...e, { animationFrame: p === "always" }), "whileElementsMounted"),
		elements: { reference: _.anchor },
		middleware: [
			Kn({
				mainAxis: i + T,
				alignmentAxis: o
			}),
			c && qn({
				mainAxis: !0,
				crossAxis: !1,
				limiter: d === "partial" ? Jn() : void 0,
				...j
			}),
			c && Vn({ ...j }),
			Yn({
				...j,
				apply: /* @__PURE__ */ X(({ elements: e, rects: t, availableWidth: n, availableHeight: r }) => {
					let { width: i, height: a } = t.reference, o = e.floating.style;
					o.setProperty("--radix-popper-available-width", `${n}px`), o.setProperty("--radix-popper-available-height", `${r}px`), o.setProperty("--radix-popper-anchor-width", `${i}px`), o.setProperty("--radix-popper-anchor-height", `${a}px`);
				}, "apply")
			}),
			x && Ir({
				element: x,
				padding: s
			}),
			oi({
				arrowWidth: w,
				arrowHeight: T
			}),
			f && Wn({
				strategy: "referenceHidden",
				...j,
				boundary: A ? j.boundary : void 0
			})
		]
	}), ne = _.setPlacementState;
	V(() => (ne(ee), () => {
		ne(void 0);
	}), [ee, ne]);
	let [re, ie] = si(ee), ae = Dt(h);
	V(() => {
		te && ae?.();
	}, [te, ae]);
	let oe = P.arrow?.x, se = P.arrow?.y, ce = P.arrow?.centerOffset !== 0, [le, ue] = m.useState();
	return V(() => {
		v && ue(window.getComputedStyle(v).zIndex);
	}, [v]), /* @__PURE__ */ E("div", {
		ref: M.setFloating,
		"data-radix-popper-content-wrapper": "",
		style: {
			...N,
			transform: te ? N.transform : "translate(0, -200%)",
			minWidth: "max-content",
			zIndex: le,
			"--radix-popper-transform-origin": [P.transformOrigin?.x, P.transformOrigin?.y].join(" "),
			...P.hide?.referenceHidden && {
				visibility: "hidden",
				pointerEvents: "none"
			}
		},
		dir: e.dir,
		children: /* @__PURE__ */ E(ni, {
			scope: n,
			placedSide: re,
			placedAlign: ie,
			onArrowChange: S,
			arrowX: oe,
			arrowY: se,
			shouldHideArrow: ce,
			children: /* @__PURE__ */ E(Ct.div, {
				"data-side": re,
				"data-align": ie,
				...g,
				ref: b,
				style: {
					...g.style,
					animation: te ? g.style?.animation : "none"
				}
			})
		})
	});
}, "PopperContent"));
function ai(e) {
	return e !== null;
}
X(ai, "isNotNull");
var oi = /* @__PURE__ */ X((e) => ({
	name: "transformOrigin",
	options: e,
	fn(t) {
		let { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, s = a ? 0 : e.arrowHeight, [c, l] = si(n), u = {
			start: "0%",
			center: "50%",
			end: "100%"
		}[l], d = (i.arrow?.x ?? 0) + o / 2, f = (i.arrow?.y ?? 0) + s / 2, p = "", m = "";
		return c === "bottom" ? (p = a ? u : `${d}px`, m = `${-s}px`) : c === "top" ? (p = a ? u : `${d}px`, m = `${r.floating.height + s}px`) : c === "right" ? (p = `${-s}px`, m = a ? u : `${f}px`) : c === "left" && (p = `${r.floating.width + s}px`, m = a ? u : `${f}px`), { data: {
			x: p,
			y: m
		} };
	}
}), "transformOrigin");
function si(e) {
	let [t, n = "center"] = e.split("-");
	return [t, n];
}
X(si, "getSideAndAlignFromPlacement");
var ci = Qr, li = ei, ui = ii, di = Object.defineProperty, fi = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ ((e, t) => di(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { container: n, ...r } = e, [i, a] = m.useState(!1);
	V(() => a(!0), []);
	let o = n || i && globalThis?.document?.body;
	return o ? O.createPortal(/* @__PURE__ */ E(Ct.div, {
		...r,
		ref: t
	}), o) : null;
}, "Portal")), pi = Object.defineProperty, Z = (e, t) => pi(e, "name", {
	value: t,
	configurable: !0
});
function mi(e, t) {
	return m.useReducer((e, n) => t[e][n] ?? e, e);
}
Z(mi, "useStateMachine");
var hi = /* @__PURE__ */ Z((e) => {
	let { present: t, children: n } = e, r = gi(t), i = typeof n == "function" ? n({ present: r.isPresent }) : m.Children.only(n), a = vi(r.ref, bi(i));
	return typeof n == "function" || r.isPresent ? m.cloneElement(i, { ref: a }) : null;
}, "Presence");
function gi(e) {
	let [t, n] = m.useState(), r = m.useRef(null), i = m.useRef(e), a = m.useRef("none"), o = m.useRef(void 0), [s, c] = mi(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return m.useEffect(() => {
		s === "mounted" ? (a.current = o.current ?? yi(r.current), o.current = void 0) : a.current = "none";
	}, [s]), V(() => {
		let t = r.current, n = i.current;
		if (n !== e) {
			let r = a.current, s = yi(t);
			e ? (o.current = s, c("MOUNT")) : s === "none" || t?.display === "none" ? c("UNMOUNT") : c(n && r !== s ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
		}
	}, [e, c]), V(() => {
		if (t) {
			let e, n = t.ownerDocument.defaultView ?? window, o = /* @__PURE__ */ Z((a) => {
				let o = yi(r.current).includes(CSS.escape(a.animationName));
				if (a.target === t && o && (c("ANIMATION_END"), !i.current)) {
					let r = t.style.animationFillMode;
					t.style.animationFillMode = "forwards", e = n.setTimeout(() => {
						t.style.animationFillMode === "forwards" && (t.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ Z((e) => {
				e.target === t && (a.current = yi(r.current));
			}, "handleAnimationStart");
			return t.addEventListener("animationstart", s), t.addEventListener("animationcancel", o), t.addEventListener("animationend", o), () => {
				n.clearTimeout(e), t.removeEventListener("animationstart", s), t.removeEventListener("animationcancel", o), t.removeEventListener("animationend", o);
			};
		} else c("ANIMATION_END");
	}, [t, c]), {
		isPresent: ["mounted", "unmountSuspended"].includes(s),
		ref: m.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				r.current = t, o.current = yi(t);
			} else r.current = null;
			n(e);
		}, [])
	};
}
Z(gi, "usePresence");
function _i(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Z(_i, "setRef");
function vi(...e) {
	let t = m.useRef(e);
	return t.current = e, m.useCallback((e) => {
		let n = t.current, r = !1, i = n.map((t) => {
			let n = _i(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let t = i[e];
				typeof t == "function" ? t() : _i(n[e], null);
			}
		};
	}, []);
}
Z(vi, "useStableComposedRefs");
function yi(e) {
	return e?.animationName || "none";
}
Z(yi, "getAnimationName");
function bi(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Z(bi, "getElementRef");
//#endregion
//#region ../../../node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var xi = Object.defineProperty, Si = (e, t) => xi(e, "name", {
	value: t,
	configurable: !0
}), Ci = m.useEffectEvent, wi = m.useInsertionEffect;
function Ti(e) {
	if (typeof Ci == "function") return Ci(e);
	let t = m.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof wi == "function" ? wi(() => {
		t.current = e;
	}) : V(() => {
		t.current = e;
	}), m.useMemo(() => ((...e) => t.current?.(...e)), []);
}
Si(Ti, "useEffectEvent");
//#endregion
//#region ../../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var Ei = Object.defineProperty, Di = (e, t) => Ei(e, "name", {
	value: t,
	configurable: !0
}), Oi = m.useInsertionEffect || V;
function ki({ prop: e, defaultProp: t, onChange: n = /* @__PURE__ */ Di(() => {}, "onChange"), caller: r }) {
	let [i, a, o] = Ai({
		defaultProp: t,
		onChange: n
	}), s = e !== void 0;
	return [s ? e : i, m.useCallback((t) => {
		if (s) {
			let n = ji(t) ? t(e) : t;
			n !== e && o.current?.(n);
		} else a(t);
	}, [
		s,
		e,
		a,
		o
	])];
}
Di(ki, "useControllableState");
function Ai({ defaultProp: e, onChange: t }) {
	let [n, r] = m.useState(e), i = m.useRef(n), a = m.useRef(t);
	return Oi(() => {
		a.current = t;
	}, [t]), m.useEffect(() => {
		i.current !== n && (a.current?.(n), i.current = n);
	}, [n, i]), [
		n,
		r,
		a
	];
}
Di(Ai, "useUncontrolledState");
function ji(e) {
	return typeof e == "function";
}
Di(ji, "isFunction");
var Mi = Symbol("RADIX:SYNC_STATE");
function Ni(e, t, n, r) {
	let { prop: i, defaultProp: a, onChange: o, caller: s } = t, c = i !== void 0, l = Ti(o), u = [{
		...n,
		state: a
	}];
	r && u.push(r);
	let [d, f] = m.useReducer((t, n) => {
		if (n.type === Mi) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return c && !Object.is(r.state, t.state) && l(r.state), r;
	}, ...u), p = d.state, h = m.useRef(p);
	m.useEffect(() => {
		h.current !== p && (h.current = p, c || l(p));
	}, [
		p,
		h,
		c
	]);
	let g = m.useMemo(() => i === void 0 ? d : {
		...d,
		state: i
	}, [d, i]);
	return m.useEffect(() => {
		c && !Object.is(i, d.state) && f({
			type: Mi,
			state: i
		});
	}, [
		i,
		d.state,
		c
	]), [g, f];
}
Di(Ni, "useControllableStateReducer");
//#endregion
//#region ../../../node_modules/aria-hidden/dist/es2015/index.js
var Pi = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, Fi = /* @__PURE__ */ new WeakMap(), Ii = /* @__PURE__ */ new WeakMap(), Li = {}, Ri = 0, zi = function(e) {
	return e && (e.host || zi(e.parentNode));
}, Bi = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = zi(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Vi = function(e, t, n, r) {
	var i = Bi(t, Array.isArray(e) ? e : [e]);
	Li[n] || (Li[n] = /* @__PURE__ */ new WeakMap());
	var a = Li[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (Fi.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				Fi.set(e, c), a.set(e, l), o.push(e), c === 1 && i && Ii.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), Ri++, function() {
		o.forEach(function(e) {
			var t = Fi.get(e) - 1, i = a.get(e) - 1;
			Fi.set(e, t), a.set(e, i), t || (Ii.has(e) || e.removeAttribute(r), Ii.delete(e)), i || e.removeAttribute(n);
		}), Ri--, Ri || (Fi = /* @__PURE__ */ new WeakMap(), Fi = /* @__PURE__ */ new WeakMap(), Ii = /* @__PURE__ */ new WeakMap(), Li = {});
	};
}, Hi = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || Pi(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), Vi(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, Q = function() {
	return Q = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, Q.apply(this, arguments);
};
function Ui(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function Wi(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Gi = "right-scroll-bar-position", Ki = "width-before-scroll-bar", qi = "with-scroll-bars-hidden", Ji = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function Yi(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../../node_modules/use-callback-ref/dist/es2015/useRef.js
function Xi(e, t) {
	var n = w(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var Zi = typeof window < "u" ? m.useLayoutEffect : m.useEffect, Qi = /* @__PURE__ */ new WeakMap();
function $i(e, t) {
	var n = Xi(t || null, function(t) {
		return e.forEach(function(e) {
			return Yi(e, t);
		});
	});
	return Zi(function() {
		var t = Qi.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || Yi(e, null);
			}), i.forEach(function(e) {
				r.has(e) || Yi(e, a);
			});
		}
		Qi.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../../../node_modules/use-sidecar/dist/es2015/medium.js
function ea(e) {
	return e;
}
function ta(e, t) {
	t === void 0 && (t = ea);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function na(e) {
	e === void 0 && (e = {});
	var t = ta(null);
	return t.options = Q({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../../node_modules/use-sidecar/dist/es2015/exports.js
var ra = function(e) {
	var t = e.sideCar, n = Ui(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var r = t.read();
	if (!r) throw Error("Sidecar medium not found");
	return m.createElement(r, Q({}, n));
};
ra.isSideCarExport = !0;
function ia(e, t) {
	return e.useMedium(t), ra;
}
//#endregion
//#region ../../../node_modules/react-remove-scroll/dist/es2015/medium.js
var aa = na(), oa = function() {}, sa = m.forwardRef(function(e, t) {
	var n = m.useRef(null), r = m.useState({
		onScrollCapture: oa,
		onWheelCapture: oa,
		onTouchMoveCapture: oa
	}), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noRelative, h = e.noIsolation, g = e.inert, _ = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, b = e.gapMode, x = Ui(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = f, C = $i([n, t]), w = Q(Q({}, x), i);
	return m.createElement(m.Fragment, null, u && m.createElement(S, {
		sideCar: aa,
		removeScrollBar: l,
		shards: d,
		noRelative: p,
		noIsolation: h,
		inert: g,
		setCallbacks: a,
		allowPinchZoom: !!_,
		lockRef: n,
		gapMode: b
	}), o ? m.cloneElement(m.Children.only(s), Q(Q({}, w), { ref: C })) : m.createElement(y, Q({}, w, {
		className: c,
		ref: C
	}), s));
});
sa.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, sa.classNames = {
	fullWidth: Ki,
	zeroRight: Gi
};
//#endregion
//#region ../../../node_modules/get-nonce/dist/es2015/index.js
var ca, la = function() {
	if (ca) return ca;
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../../node_modules/react-style-singleton/dist/es2015/singleton.js
function ua() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = la();
	return t && e.setAttribute("nonce", t), e;
}
function da(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function fa(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var pa = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = ua()) && (da(t, n), fa(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, ma = function() {
	var e = pa();
	return function(t, n) {
		m.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, ha = function() {
	var e = ma();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, ga = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, _a = function(e) {
	return parseInt(e || "", 10) || 0;
}, va = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		_a(n),
		_a(r),
		_a(i)
	];
}, ya = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return ga;
	var t = va(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, ba = ha(), xa = "data-scroll-locked", Sa = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${qi} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${xa}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Gi} {
    right: ${s}px ${r};
  }
  
  .${Ki} {
    margin-right: ${s}px ${r};
  }
  
  .${Gi} .${Gi} {
    right: 0 ${r};
  }
  
  .${Ki} .${Ki} {
    margin-right: 0 ${r};
  }
  
  body[${xa}] {
    ${Ji}: ${s}px;
  }
`;
}, Ca = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, wa = function() {
	m.useEffect(function() {
		return document.body.setAttribute(xa, (Ca() + 1).toString()), function() {
			var e = Ca() - 1;
			e <= 0 ? document.body.removeAttribute(xa) : document.body.setAttribute(xa, e.toString());
		};
	}, []);
}, Ta = function(e) {
	var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
	wa();
	var a = m.useMemo(function() {
		return ya(i);
	}, [i]);
	return m.createElement(ba, { styles: Sa(a, !t, i, n ? "" : "!important") });
}, Ea = !1;
if (typeof window < "u") try {
	var Da = Object.defineProperty({}, "passive", { get: function() {
		return Ea = !0, !0;
	} });
	window.addEventListener("test", Da, Da), window.removeEventListener("test", Da, Da);
} catch {
	Ea = !1;
}
var Oa = Ea ? { passive: !1 } : !1, ka = function(e) {
	return e.tagName === "TEXTAREA";
}, Aa = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !ka(e) && n[t] === "visible");
}, ja = function(e) {
	return Aa(e, "overflowY");
}, Ma = function(e) {
	return Aa(e, "overflowX");
}, Na = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Ia(e, r)) {
			var i = La(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, Pa = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, Fa = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Ia = function(e, t) {
	return e === "v" ? ja(t) : Ma(t);
}, La = function(e, t) {
	return e === "v" ? Pa(t) : Fa(t);
}, Ra = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, za = function(e, t, n, r, i) {
	var a = Ra(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = La(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Ia(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Ba = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Va = function(e) {
	return [e.deltaX, e.deltaY];
}, Ha = function(e) {
	return e && "current" in e ? e.current : e;
}, Ua = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, Wa = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, Ga = 0, Ka = [];
function qa(e) {
	var t = m.useRef([]), n = m.useRef([0, 0]), r = m.useRef(), i = m.useState(Ga++)[0], a = m.useState(ha)[0], o = m.useRef(e);
	m.useEffect(function() {
		o.current = e;
	}, [e]), m.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${i}`);
			var t = Wi([e.lockRef.current], (e.shards || []).map(Ha), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${i}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${i}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${i}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var s = m.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !o.current.allowPinchZoom;
		var i = Ba(e), a = n.current, s = "deltaX" in e ? e.deltaX : a[0] - i[0], c = "deltaY" in e ? e.deltaY : a[1] - i[1], l, u = e.target, d = Math.abs(s) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = Na(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = Na(d, u)), !m) return !1;
		if (!r.current && "changedTouches" in e && (s || c) && (r.current = l), !l) return !0;
		var h = r.current || l;
		return za(h, t, e, h === "h" ? s : c, !0);
	}, []), c = m.useCallback(function(e) {
		var n = e;
		if (!(!Ka.length || Ka[Ka.length - 1] !== a)) {
			var r = "deltaY" in n ? Va(n) : Ba(n), i = t.current.filter(function(e) {
				return e.name === n.type && (e.target === n.target || n.target === e.shadowParent) && Ua(e.delta, r);
			})[0];
			if (i && i.should) {
				n.cancelable && n.preventDefault();
				return;
			}
			if (!i) {
				var c = (o.current.shards || []).map(Ha).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(c.length > 0 ? s(n, c[0]) : !o.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), l = m.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i,
			shadowParent: Ja(r)
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), u = m.useCallback(function(e) {
		n.current = Ba(e), r.current = void 0;
	}, []), d = m.useCallback(function(t) {
		l(t.type, Va(t), t.target, s(t, e.lockRef.current));
	}, []), f = m.useCallback(function(t) {
		l(t.type, Ba(t), t.target, s(t, e.lockRef.current));
	}, []);
	m.useEffect(function() {
		return Ka.push(a), e.setCallbacks({
			onScrollCapture: d,
			onWheelCapture: d,
			onTouchMoveCapture: f
		}), document.addEventListener("wheel", c, Oa), document.addEventListener("touchmove", c, Oa), document.addEventListener("touchstart", u, Oa), function() {
			Ka = Ka.filter(function(e) {
				return e !== a;
			}), document.removeEventListener("wheel", c, Oa), document.removeEventListener("touchmove", c, Oa), document.removeEventListener("touchstart", u, Oa);
		};
	}, []);
	var p = e.removeScrollBar, h = e.inert;
	return m.createElement(m.Fragment, null, h ? m.createElement(a, { styles: Wa(i) }) : null, p ? m.createElement(Ta, {
		noRelative: e.noRelative,
		gapMode: e.gapMode
	}) : null);
}
function Ja(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var Ya = ia(aa, qa), Xa = m.forwardRef(function(e, t) {
	return m.createElement(sa, Q({}, e, {
		ref: t,
		sideCar: Ya
	}));
});
Xa.classNames = sa.classNames;
//#endregion
//#region ../../../node_modules/@radix-ui/react-popover/dist/index.mjs
var Za = Object.defineProperty, Qa = (e, t) => Za(e, "name", {
	value: t,
	configurable: !0
}), $a = "Popover", [eo, to] = /* @__PURE__ */ at($a, [Yr]), no = Yr(), [ro, io] = eo($a), ao = /* @__PURE__ */ Qa((e) => {
	let { __scopePopover: t, children: n, open: r, defaultOpen: i, onOpenChange: a, modal: o = !1 } = e, s = no(t), c = m.useRef(null), [l, u] = m.useState(!1), [d, f] = ki({
		prop: r,
		defaultProp: i ?? !1,
		onChange: a,
		caller: $a
	});
	return /* @__PURE__ */ E(ci, {
		...s,
		children: /* @__PURE__ */ E(ro, {
			scope: t,
			contentId: mn(),
			triggerRef: c,
			open: d,
			onOpenChange: f,
			onOpenToggle: m.useCallback(() => f((e) => !e), [f]),
			hasCustomAnchor: l,
			onCustomAnchorAdd: m.useCallback(() => u(!0), []),
			onCustomAnchorRemove: m.useCallback(() => u(!1), []),
			modal: o,
			children: n
		})
	});
}, "Popover"), oo = "PopoverTrigger", so = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Qa(function(e, t) {
	let { __scopePopover: n, ...r } = e, i = io(oo, n), a = no(n), o = nt(t, i.triggerRef), s = /* @__PURE__ */ E(Ct.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": yo(i.open),
		...r,
		ref: o,
		onClick: F(e.onClick, i.onOpenToggle)
	});
	return i.hasCustomAnchor ? s : /* @__PURE__ */ E(li, {
		asChild: !0,
		...a,
		children: s
	});
}, "PopoverTrigger")), co = "PopoverPortal", [lo, uo] = eo(co, { forceMount: void 0 }), fo = /* @__PURE__ */ Qa((e) => {
	let { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = io(co, t);
	return /* @__PURE__ */ E(lo, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ E(hi, {
			present: n || a.open,
			children: /* @__PURE__ */ E(fi, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "PopoverPortal"), po = "PopoverContent", mo = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Qa(function(e, t) {
	let n = uo(po, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = io(po, e.__scopePopover);
	return /* @__PURE__ */ E(hi, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ E(go, {
			...i,
			ref: t
		}) : /* @__PURE__ */ E(_o, {
			...i,
			ref: t
		})
	});
}, "PopoverContent")), ho = /* @__PURE__ */ ct("PopoverContent.RemoveScroll"), go = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Qa(function(e, t) {
	let n = io(po, e.__scopePopover), r = m.useRef(null), i = nt(t, r), a = m.useRef(!1);
	return m.useEffect(() => {
		let e = r.current;
		if (e) return Hi(e);
	}, []), /* @__PURE__ */ E(Xa, {
		as: ho,
		allowPinchZoom: !0,
		children: /* @__PURE__ */ E(vo, {
			...e,
			ref: i,
			trapFocus: n.open,
			disableOutsidePointerEvents: !0,
			onCloseAutoFocus: F(e.onCloseAutoFocus, (e) => {
				e.preventDefault(), a.current || n.triggerRef.current?.focus();
			}),
			onPointerDownOutside: F(e.onPointerDownOutside, (e) => {
				let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
				a.current = r;
			}, { checkForDefaultPrevented: !1 }),
			onFocusOutside: F(e.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 })
		})
	});
}, "PopoverContentModal")), _o = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Qa(function(e, t) {
	let n = io(po, e.__scopePopover), r = m.useRef(!1), i = m.useRef(!1);
	return /* @__PURE__ */ E(vo, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let a = t.target;
			n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	});
}, "PopoverContentNonModal")), vo = /* @__PURE__ */ m.forwardRef(/* @__PURE__ */ Qa(function(e, t) {
	let { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, f = io(po, n), p = no(n);
	return Kt(), /* @__PURE__ */ E(Qt, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ E(Pt, {
			asChild: !0,
			disableOutsidePointerEvents: o,
			onInteractOutside: u,
			onEscapeKeyDown: s,
			onPointerDownOutside: c,
			onFocusOutside: l,
			onDismiss: () => f.onOpenChange(!1),
			deferPointerDownOutside: !0,
			children: /* @__PURE__ */ E(ui, {
				"data-state": yo(f.open),
				role: "dialog",
				id: f.contentId,
				...p,
				...d,
				ref: t,
				style: {
					...d.style,
					"--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
					"--radix-popover-content-available-width": "var(--radix-popper-available-width)",
					"--radix-popover-content-available-height": "var(--radix-popper-available-height)",
					"--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
					"--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
				}
			})
		})
	});
}, "PopoverContentImpl"));
function yo(e) {
	return e ? "open" : "closed";
}
Qa(yo, "getState");
var bo = ao, xo = so, So = fo, Co = mo, wo = {
	tooltip: "_tooltip_5svgn_1",
	popover: "_popover_5svgn_5"
}, To = ({ actions: e, buttonProps: { onClick: t, ...n } = {}, side: r = "bottom", align: a = "end" }) => {
	let [o, c] = w(!1), u = y((e) => {
		e.stopPropagation(), t?.(e);
	}, [t]);
	if (!e.length) return null;
	let d = (e, t) => {
		switch (e.type) {
			case "button":
			case "link": {
				let n = /* @__PURE__ */ E(i.Item, {
					icon: e.icon,
					onClick: (t) => {
						e.onClick?.(t), c(!1);
					},
					isDisabled: e.disabled ?? !1,
					children: /* @__PURE__ */ D(s, {
						as: "span",
						flexDirection: "column",
						alignItems: "flex-start",
						gap: "2px",
						children: [/* @__PURE__ */ E("span", { children: e.label }), e.description && /* @__PURE__ */ E(f.Paragraph, {
							as: "span",
							variant: "4",
							subdued: !0,
							children: e.description
						})]
					})
				});
				return /* @__PURE__ */ E(p, {
					className: wo.tooltip,
					content: e.tooltip,
					children: e.type === "link" ? g(e.link, { children: n }) : n
				}, t);
			}
			case "divider": return /* @__PURE__ */ E(i.Divider, {}, t);
			default: return null;
		}
	};
	return /* @__PURE__ */ D(bo, {
		open: o,
		onOpenChange: c,
		children: [/* @__PURE__ */ E(xo, {
			asChild: !0,
			children: /* @__PURE__ */ E(l, {
				variant: "tertiary",
				icon: "dots-v",
				onClick: u,
				...n
			})
		}), /* @__PURE__ */ E(So, { children: /* @__PURE__ */ E(Co, {
			className: wo.popover,
			side: r,
			align: a,
			sideOffset: 8,
			onOpenAutoFocus: (e) => e.preventDefault(),
			children: /* @__PURE__ */ E(i, { children: e.map((e, t) => d(e, t)) })
		}) })]
	});
}, Eo = /* @__PURE__ */ Be(((e, t) => {
	t.exports = { ...m };
})), Do = /* @__PURE__ */ Ve({ CountUp: () => ko }), Oo, ko, Ao = ze((() => {
	Oo = function() {
		return (Oo = Object.assign || function(e) {
			for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e;
		}).apply(this, arguments);
	}, ko = function() {
		function e(e, t, n) {
			var r = this;
			this.endVal = t, this.options = n, this.version = "2.6.0", this.defaults = {
				startVal: 0,
				decimalPlaces: 0,
				duration: 2,
				useEasing: !0,
				useGrouping: !0,
				useIndianSeparators: !1,
				smartEasingThreshold: 999,
				smartEasingAmount: 333,
				separator: ",",
				decimal: ".",
				prefix: "",
				suffix: "",
				enableScrollSpy: !1,
				scrollSpyDelay: 200,
				scrollSpyOnce: !1
			}, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(e) {
				r.startTime ||= e;
				var t = e - r.startTime;
				r.remaining = r.duration - t, r.useEasing ? r.countDown ? r.frameVal = r.startVal - r.easingFn(t, 0, r.startVal - r.endVal, r.duration) : r.frameVal = r.easingFn(t, r.startVal, r.endVal - r.startVal, r.duration) : r.frameVal = r.startVal + (r.endVal - r.startVal) * (t / r.duration), r.frameVal = (r.countDown ? r.frameVal < r.endVal : r.frameVal > r.endVal) ? r.endVal : r.frameVal, r.frameVal = Number(r.frameVal.toFixed(r.options.decimalPlaces)), r.printValue(r.frameVal), t < r.duration ? r.rAF = requestAnimationFrame(r.count) : r.finalEndVal === null ? r.options.onCompleteCallback && r.options.onCompleteCallback() : r.update(r.finalEndVal);
			}, this.formatNumber = function(e) {
				var t, n, i, a, o = e < 0 ? "-" : "";
				t = Math.abs(e).toFixed(r.options.decimalPlaces);
				var s = (t += "").split(".");
				if (n = s[0], i = s.length > 1 ? r.options.decimal + s[1] : "", r.options.useGrouping) {
					a = "";
					for (var c = 3, l = 0, u = 0, d = n.length; u < d; ++u) r.options.useIndianSeparators && u === 4 && (c = 2, l = 1), u !== 0 && l % c == 0 && (a = r.options.separator + a), l++, a = n[d - u - 1] + a;
					n = a;
				}
				return r.options.numerals && r.options.numerals.length && (n = n.replace(/[0-9]/g, function(e) {
					return r.options.numerals[+e];
				}), i = i.replace(/[0-9]/g, function(e) {
					return r.options.numerals[+e];
				})), o + r.options.prefix + n + i + r.options.suffix;
			}, this.easeOutExpo = function(e, t, n, r) {
				return n * (1 - 2 ** (-10 * e / r)) * 1024 / 1023 + t;
			}, this.options = Oo(Oo({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(t), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = !1), this.el = typeof e == "string" ? document.getElementById(e) : e, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window < "u" && this.options.enableScrollSpy && (this.error ? console.error(this.error, e) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
				return r.handleScroll(r);
			}), window.onscroll = function() {
				window.onScrollFns.forEach(function(e) {
					return e();
				});
			}, this.handleScroll(this)));
		}
		return e.prototype.handleScroll = function(e) {
			if (e && window && !e.once) {
				var t = window.innerHeight + window.scrollY, n = e.el.getBoundingClientRect(), r = n.top + window.pageYOffset, i = n.top + n.height + window.pageYOffset;
				i < t && i > window.scrollY && e.paused ? (e.paused = !1, setTimeout(function() {
					return e.start();
				}, e.options.scrollSpyDelay), e.options.scrollSpyOnce && (e.once = !0)) : (window.scrollY > i || r > t) && !e.paused && e.reset();
			}
		}, e.prototype.determineDirectionAndSmartEasing = function() {
			var e = this.finalEndVal ? this.finalEndVal : this.endVal;
			this.countDown = this.startVal > e;
			var t = e - this.startVal;
			if (Math.abs(t) > this.options.smartEasingThreshold && this.options.useEasing) {
				this.finalEndVal = e;
				var n = this.countDown ? 1 : -1;
				this.endVal = e + n * this.options.smartEasingAmount, this.duration /= 2;
			} else this.endVal = e, this.finalEndVal = null;
			this.finalEndVal === null ? this.useEasing = this.options.useEasing : this.useEasing = !1;
		}, e.prototype.start = function(e) {
			this.error || (e && (this.options.onCompleteCallback = e), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
		}, e.prototype.pauseResume = function() {
			this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
		}, e.prototype.reset = function() {
			cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
		}, e.prototype.update = function(e) {
			cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(e), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal ?? this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
		}, e.prototype.printValue = function(e) {
			var t;
			if (this.el) {
				var n = this.formattingFn(e);
				(t = this.options.plugin) != null && t.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
			}
		}, e.prototype.ensureNumber = function(e) {
			return typeof e == "number" && !isNaN(e);
		}, e.prototype.validateValue = function(e) {
			var t = Number(e);
			return this.ensureNumber(t) ? t : (this.error = `[CountUp] invalid start or end value: ${e}`, null);
		}, e.prototype.resetDuration = function() {
			this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
		}, e;
	}();
})), jo = /* @__PURE__ */ Ue((/* @__PURE__ */ Be(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = Eo(), n = (Ao(), We(Do));
	function r(e, t) {
		var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (n != null) {
			var r, i, a, o, s = [], c = !0, l = !1;
			try {
				if (a = (n = n.call(e)).next, t === 0) {
					if (Object(n) !== n) return;
					c = !1;
				} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
			} catch (e) {
				l = !0, i = e;
			} finally {
				try {
					if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
				} finally {
					if (l) throw i;
				}
			}
			return s;
		}
	}
	function i(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function a(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t] == null ? {} : arguments[t];
			t % 2 ? i(Object(n), !0).forEach(function(t) {
				o(e, t, n[t]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
				Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
			});
		}
		return e;
	}
	function o(e, t, n) {
		return t = g(t), t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function s() {
		return s = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, s.apply(this, arguments);
	}
	function c(e, t) {
		if (e == null) return {};
		var n = {}, r = Object.keys(e), i, a;
		for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
		return n;
	}
	function l(e, t) {
		if (e == null) return {};
		var n = c(e, t), r, i;
		if (Object.getOwnPropertySymbols) {
			var a = Object.getOwnPropertySymbols(e);
			for (i = 0; i < a.length; i++) r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
		}
		return n;
	}
	function u(e, t) {
		return d(e) || r(e, t) || f(e, t) || m();
	}
	function d(e) {
		if (Array.isArray(e)) return e;
	}
	function f(e, t) {
		if (e) {
			if (typeof e == "string") return p(e, t);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
			if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return p(e, t);
		}
	}
	function p(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	function m() {
		throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function h(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	function g(e) {
		var t = h(e, "string");
		return typeof t == "symbol" ? t : String(t);
	}
	var _ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? t.useLayoutEffect : t.useEffect;
	function v(e) {
		var n = t.useRef(e);
		return _(function() {
			n.current = e;
		}), t.useCallback(function() {
			var e = [...arguments];
			return n.current.apply(void 0, e);
		}, []);
	}
	var y = function(e, t) {
		var r = t.decimal, i = t.decimals, a = t.duration, o = t.easingFn, s = t.end, c = t.formattingFn, l = t.numerals, u = t.prefix, d = t.separator, f = t.start, p = t.suffix, m = t.useEasing, h = t.useGrouping, g = t.useIndianSeparators, _ = t.enableScrollSpy, v = t.scrollSpyDelay, y = t.scrollSpyOnce;
		return new n.CountUp(e, s, {
			startVal: f,
			duration: a,
			decimal: r,
			decimalPlaces: i,
			easingFn: o,
			formattingFn: c,
			numerals: l,
			separator: d,
			prefix: u,
			suffix: p,
			useEasing: m,
			useIndianSeparators: g,
			useGrouping: h,
			enableScrollSpy: _,
			scrollSpyDelay: v,
			scrollSpyOnce: y
		});
	}, b = [
		"ref",
		"startOnMount",
		"enableReinitialize",
		"delay",
		"onEnd",
		"onStart",
		"onPauseResume",
		"onReset",
		"onUpdate"
	], x = {
		decimal: ".",
		separator: ",",
		delay: null,
		prefix: "",
		suffix: "",
		duration: 2,
		start: 0,
		decimals: 0,
		startOnMount: !0,
		enableReinitialize: !0,
		useEasing: !0,
		useGrouping: !0,
		useIndianSeparators: !1
	}, S = function(e) {
		var n = Object.fromEntries(Object.entries(e).filter(function(e) {
			return u(e, 2)[1] !== void 0;
		})), r = t.useMemo(function() {
			return a(a({}, x), n);
		}, [e]), i = r.ref, o = r.startOnMount, s = r.enableReinitialize, c = r.delay, d = r.onEnd, f = r.onStart, p = r.onPauseResume, m = r.onReset, h = r.onUpdate, g = l(r, b), _ = t.useRef(), S = t.useRef(), C = t.useRef(!1), w = v(function() {
			return y(typeof i == "string" ? i : i.current, g);
		}), T = v(function(e) {
			var t = _.current;
			if (t && !e) return t;
			var n = w();
			return _.current = n, n;
		}), E = v(function() {
			var e = function() {
				return T(!0).start(function() {
					d?.({
						pauseResume: D,
						reset: O,
						start: A,
						update: k
					});
				});
			};
			c && c > 0 ? S.current = setTimeout(e, c * 1e3) : e(), f?.({
				pauseResume: D,
				reset: O,
				update: k
			});
		}), D = v(function() {
			T().pauseResume(), p?.({
				reset: O,
				start: A,
				update: k
			});
		}), O = v(function() {
			T().el && (S.current && clearTimeout(S.current), T().reset(), m?.({
				pauseResume: D,
				start: A,
				update: k
			}));
		}), k = v(function(e) {
			T().update(e), h?.({
				pauseResume: D,
				reset: O,
				start: A
			});
		}), A = v(function() {
			O(), E();
		}), j = v(function(e) {
			o && (e && O(), E());
		});
		return t.useEffect(function() {
			C.current ? s && j(!0) : (C.current = !0, j());
		}, [
			s,
			C,
			j,
			c,
			e.start,
			e.suffix,
			e.prefix,
			e.duration,
			e.separator,
			e.decimals,
			e.decimal,
			e.formattingFn
		]), t.useEffect(function() {
			return function() {
				O();
			};
		}, [O]), {
			start: A,
			pauseResume: D,
			reset: O,
			update: k,
			getCountUp: T
		};
	}, C = [
		"className",
		"redraw",
		"containerProps",
		"children",
		"style"
	];
	e.default = function(e) {
		var n = e.className, r = e.redraw, i = e.containerProps, o = e.children, c = e.style, u = l(e, C), d = t.useRef(null), f = t.useRef(!1), p = S(a(a({}, u), {}, {
			ref: d,
			startOnMount: typeof o != "function" || e.delay === 0,
			enableReinitialize: !1
		})), m = p.start, h = p.reset, g = p.update, _ = p.pauseResume, y = p.getCountUp, b = v(function() {
			m();
		}), x = v(function(t) {
			e.preserveValue || h(), g(t);
		}), w = v(function() {
			if (typeof e.children == "function" && !(d.current instanceof Element)) {
				console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
				return;
			}
			y();
		});
		t.useEffect(function() {
			w();
		}, [w]), t.useEffect(function() {
			f.current && x(e.end);
		}, [e.end, x]);
		var T = r && e;
		return t.useEffect(function() {
			r && f.current && b();
		}, [
			b,
			r,
			T
		]), t.useEffect(function() {
			!r && f.current && b();
		}, [
			b,
			r,
			e.start,
			e.suffix,
			e.prefix,
			e.duration,
			e.separator,
			e.decimals,
			e.decimal,
			e.className,
			e.formattingFn
		]), t.useEffect(function() {
			f.current = !0;
		}, []), typeof o == "function" ? o({
			countUpRef: d,
			start: m,
			reset: h,
			update: g,
			pauseResume: _,
			getCountUp: y
		}) : /*#__PURE__*/ t.createElement("span", s({
			className: n,
			ref: d,
			style: c
		}, i), e.start === void 0 ? "" : y().formattingFn(e.start));
	}, e.useCountUp = S;
})))()), Mo = {
	bar: "_bar_1n5dj_1",
	section: "_section_1n5dj_5",
	sectionHidden: "_sectionHidden_1n5dj_8",
	sectionInheritRadius: "_sectionInheritRadius_1n5dj_11",
	valueOutside: "_valueOutside_1n5dj_15"
}, No = ({ value: e, label: n, labelWidth: r, theme: i = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"], showFullBar: a = !1, showDifference: o = !1 }) => {
	let c = Math.min(e, 100), [l, u] = w([null, null]), d = N(l);
	b(() => {
		u([c, ...a ? [100 - c] : []]);
	}, [c, a]);
	let p = 1.5, m = S(() => l.map((e, t) => {
		let n = c && t === 0 || o, r = e !== null && e < 20, l = k(Mo.section, {
			[Mo.sectionHidden]: a && e === 0,
			[Mo.sectionInheritRadius]: !a
		}), u = k(Mo.section, { [Mo.valueOutside]: r });
		return /* @__PURE__ */ E(s, {
			justifyContent: "flex-end",
			alignItems: "center",
			padding: "0 100",
			background: i[t],
			color: "neutral.000",
			className: l,
			style: {
				flexBasis: `${e ?? 0}%`,
				transition: `flex-basis ${p}s ease-out`
			},
			children: n && /* @__PURE__ */ E(f.Paragraph, {
				className: u,
				variant: "4",
				color: t === 0 && !r ? "var(--dixa-color-neutral-000)" : "var(--dixa-color-neutral-900)",
				children: /* @__PURE__ */ E(jo.default, {
					start: d?.[t] ?? 0,
					end: e ?? 0,
					duration: p,
					delay: 0,
					suffix: "%",
					children: ({ countUpRef: e }) => /* @__PURE__ */ E("span", { ref: e })
				})
			})
		}, t);
	}), [
		c,
		i,
		o,
		a,
		l,
		d
	]);
	return /* @__PURE__ */ D(s, {
		alignItems: "center",
		gap: "200",
		children: [n && /* @__PURE__ */ E(t, {
			minWidth: r ? `${r}px` : "auto",
			children: /* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				children: n
			})
		}), /* @__PURE__ */ E(s, {
			flex: "1",
			className: Mo.bar,
			height: "20px",
			borderRadius: "50",
			children: m
		})]
	});
};
//#endregion
//#region src/utils/formatting/dateTime/dateTime.ts
function Po(e, t = { compact: !1 }) {
	if (e < 1e3) return `${(e / 1e3).toFixed(0)}s`;
	let n = Math.floor(e / 1e3 % 60), r = Math.floor(e / (1e3 * 60) % 60), i = Math.floor(e / (1e3 * 60 * 60) % 24), a = Math.floor(e / (1e3 * 60 * 60 * 24)), o = (e, t) => e > 0 ? `${e}${t}` : "";
	return [
		o(a, "d"),
		o(i, "h"),
		o(r, "m") || (t.compact ? "" : "0m"),
		o(n, "s") || (t.compact ? "" : "0s")
	].filter(Boolean).join(" ");
}
function Fo(e) {
	return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/.test(e) ? ye(e, ye.ISO_8601, !0).isValid() : !1;
}
//#endregion
//#region src/utils/formatting/number/number.ts
var Io = 1e6, Lo = 1e3;
function Ro(e) {
	if (e < Lo) return zo(e);
	let t = e >= Io, n = parseFloat((e / (t ? Io : Lo)).toFixed(1)), r = t ? "M" : "K";
	return `${zo(n)}${r}`;
}
function zo(e) {
	return e.toLocaleString(navigator.language);
}
//#endregion
//#region src/utils/instruments/categorizeInstruments/categorizeInstruments.ts
var Bo = (e) => ({
	metrics: e.filter(Vo),
	chart: e.find(Ho),
	heatmap: e.find(Uo),
	table: e.find(Wo),
	presence: e.find(Go),
	insight: e.find(Ko)
}), Vo = (e) => e.type === "metric", Ho = (e) => e.type === "chart" && e.visualization !== "heatmap", Uo = (e) => e.type === "chart" && e.visualization === "heatmap", Wo = (e) => e.type === "table", Go = (e) => e.type === "presence", Ko = (e) => e.type === "ai_insight", qo = (e, t) => {
	switch (t) {
		case "duration": return Po(e).split(" ").slice(0, 2).join(" ");
		case "count": return Ro(e);
		case "number": return zo(e);
		case "percentage": return `${zo(e)}%`;
		case "timer": return Po(e);
		default: return "";
	}
}, Jo = {
	default: 8,
	rating: 5
}, Yo = be.purple[700], Xo = (e) => /^#|^rgb(a)?\(|^hsl(a)?\(|^var\(/.test(e), Zo = (e) => {
	let [t, n] = e.split("-"), r = Number(n);
	return Jo[t] ? r >= 1 && r <= Jo[t] : !1;
}, Qo = (e) => Xo(e) ? e : Zo(e) ? `var(--dixa-analytics-color-${e}, ${Yo})` : Yo, $o = (e, t = "default", n) => n ? Qo(n) : `var(--dixa-analytics-color-${t}-${e % (Jo[t] ?? Jo.default) + 1}, ${Yo})`, es = { container: "_container_1t2a7_1" }, $ = {
	tickCount: 5,
	tickProps: {
		fontFamily: "var(--dixa-typography-family-default)",
		fontSize: "var(--dixa-typography-size-200)",
		fill: "var(--dixa-typography-color-tertiary)"
	},
	visualizationIcons: {
		bar: "chart-bar",
		line: "chart-line",
		area: "chart-area",
		pie: "chart-pie",
		donut: "chart-donut"
	},
	instrumentFormatAssets: {
		count: {
			label: "#",
			description: "Absolute short numbers, e.g. 1.2K"
		},
		number: {
			label: "#",
			description: "Absolute numbers, e.g. 1.234"
		},
		percentage: {
			label: "%",
			description: "Relative percentages, e.g. 12.34%"
		},
		duration: {
			label: "s",
			description: "Durations, e.g. 12m 34s"
		}
	}
}, ts = v(function({ formats: e, onChangeFormat: t }) {
	return /* @__PURE__ */ E(r, {
		variant: "secondary",
		children: e.map(({ value: e, selected: r }) => /* @__PURE__ */ E(n, {
			onClick: r ? void 0 : () => t?.(e),
			active: r,
			title: $.instrumentFormatAssets[e]?.description,
			children: $.instrumentFormatAssets[e]?.label
		}, e))
	});
}), ns = v(function({ granularities: e, onChangeGranularity: t }) {
	return /* @__PURE__ */ E(r, {
		variant: "secondary",
		children: e.map(({ value: e, selected: r }) => /* @__PURE__ */ E(n, {
			onClick: r ? void 0 : () => t?.(e),
			active: r,
			children: e
		}, e))
	});
}), rs = {
	root: "_root_6kwn9_1",
	rootBounded: "_rootBounded_6kwn9_7",
	rootFluid: "_rootFluid_6kwn9_7"
}, is = ({ bounded: e = !1, fluid: t = !1, children: n }) => /* @__PURE__ */ E("div", {
	className: k(rs.root, {
		[rs.rootBounded]: e,
		[rs.rootFluid]: t
	}),
	children: n
}), as = v(function({ data: e }) {
	let [t, n] = w(0);
	return b(() => {
		n(Math.max(0, Date.now() - e));
	}, [e]), A(() => {
		n(Math.max(0, Date.now() - e));
	}, 1e3), /* @__PURE__ */ E(T, { children: qo(t, "timer") });
}), os = {
	wrapper: "_wrapper_1w7q6_1",
	text: "_text_1w7q6_6"
}, ss = v(function({ className: e, data: t, format: n, color: r, suffix: i }) {
	let a = S(() => {
		if (t === null) return "n.a.";
		switch (n) {
			case "timer": return /* @__PURE__ */ E(as, { data: t });
			default: return qo(t, n);
		}
	}, [t, n]), o = S(() => {
		if (t !== null) switch (n) {
			case "duration": return Po(t);
			case "count": return zo(t);
			default: return;
		}
	}, [t, n]);
	return /* @__PURE__ */ E(p, {
		content: o,
		disabled: !(t !== null && o !== a) || [
			"number",
			"percentage",
			"timer"
		].includes(n),
		wrap: "div",
		wrapProps: { className: os.wrapper },
		children: /* @__PURE__ */ D(f.Heading, {
			variant: "heading-1",
			color: r ?? (t === null ? "tertiary" : void 0),
			className: k(os.text, e),
			as: "span",
			children: [a, i]
		})
	});
}), cs = { colorIndicator: "_colorIndicator_luubh_1" }, ls = v(function({ instrument: e, theme: n = "light" }) {
	let { data: r, format: i, title: a, description: o, color: c } = e, l = c ? Qo(c) : void 0, u = n === "dark" ? "inherit" : void 0;
	return /* @__PURE__ */ D(s, {
		flexDirection: "column",
		gap: "100",
		children: [
			/* @__PURE__ */ D(s, {
				alignItems: "center",
				gap: "100",
				title: a,
				children: [c && /* @__PURE__ */ E(t, {
					as: "span",
					className: cs.colorIndicator,
					background: l
				}), /* @__PURE__ */ E(f.Paragraph, {
					variant: "4",
					color: u,
					subdued: !0,
					children: a
				})]
			}),
			/* @__PURE__ */ E(ss, {
				data: r,
				format: i,
				color: u
			}),
			o && /* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				color: u,
				subdued: !0,
				children: o
			})
		]
	});
}), us = ({ categories: e, series: t }, { omitZero: n }) => e.map((e, r) => {
	let i = t.reduce((e, { label: t, data: i }) => {
		let { value: a } = ds(i[r]);
		return (n ? !a : a === null) ? e : {
			...e,
			[t]: a
		};
	}, {});
	return {
		name: e.label,
		...i
	};
}), ds = (e) => e === null || typeof e == "number" ? { value: e } : {
	value: e?.value ?? null,
	metrics: e?.metrics
}, fs = (e) => e?.find(({ selected: e }) => e)?.value ?? "number", ps = Se, ms = (e, t = "D", { long: n = !1, timezone: r = ye.tz.guess() } = {}) => {
	let i = ye.tz(e, r), a = ye.locale() === "en", o = (e) => n ? e.format("ddd, ll") : e.format(a ? "MMM DD" : "DD MMM");
	switch (t) {
		case "H": return i.format("LT");
		case "W": return n ? `${o(i)} - ${o(i.endOf("week"))} (W${i.format("W")})` : o(i);
		case "M": return i.format(n ? "MMM YYYY" : "MMM");
		default: return o(i);
	}
}, hs = (e, t = {}) => t?.length ? ps(e, t) : e, gs = { root: "_root_scczo_54" }, _s = v(function({ instrument: e, granularity: t, timezone: n, tooltipProps: r }) {
	let { active: i, payload: a, label: o } = r, { categories: c, series: l } = e.data, u = c.find((e) => e.label === o), d = u?.metrics ?? [], p = Math.max(0, (a?.length ?? 0) - 24), m = fs(e.data.formats), h = S(() => l.length === 1 && ["count", "number"].includes(m) && !c.every(({ label: e }) => Fo(e)) ? l[0].data.reduce((e, t) => {
		let { value: n } = ds(t);
		return typeof n == "number" ? e + n : e;
	}, 0) : null, [
		c,
		m,
		l
	]), g = S(() => a?.slice(0, p > 0 ? 23 : 24).map((e) => {
		let t = e.value ?? 0, n = t && h ? t / h * 100 : null, r = n ? `${n.toFixed(2)}%` : void 0;
		return {
			type: "metric",
			title: e.name ?? "",
			color: e.color,
			data: t,
			format: m,
			description: r
		};
	}), [
		a,
		24,
		p,
		h,
		m
	]), _ = y((e) => e?.map((e) => /* @__PURE__ */ E(ls, {
		instrument: e,
		theme: "dark"
	}, e.title)), []), v = S(() => u?.label ? Fo(u.label) ? ms(u.label, t, {
		timezone: n,
		long: !0
	}) : hs(u.label) : null, [
		u?.label,
		t,
		n
	]);
	return !i || !a ? null : /* @__PURE__ */ D("div", {
		className: gs.root,
		children: [
			v && /* @__PURE__ */ D(s, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ E(f.Heading, {
					variant: "heading-2",
					color: "inherit",
					children: v
				}), u?.description && /* @__PURE__ */ E(f.Paragraph, {
					variant: "4",
					color: "inherit",
					children: u.description
				})]
			}),
			d.length > 0 && /* @__PURE__ */ E(is, {
				bounded: !0,
				children: _(d)
			}),
			/* @__PURE__ */ D(is, {
				bounded: !0,
				children: [_(g), p > 0 && /* @__PURE__ */ E(s, {
					flex: "1",
					alignItems: "center",
					children: /* @__PURE__ */ D(f.Heading, {
						variant: "heading-2",
						color: "inherit",
						children: [
							"+ ",
							p + 1,
							" more"
						]
					})
				})]
			})
		]
	});
}), vs = Ce, ys = v(function({ visualization: e, visualizations: t, onChangeVisualization: n }) {
	return t.length <= 1 ? null : /* @__PURE__ */ E(r, {
		variant: "secondary",
		children: t.map((t) => /* @__PURE__ */ E(l, {
			icon: $.visualizationIcons[t],
			onClick: () => {
				n(t);
			},
			active: e === t,
			title: `${vs(t)} chart`
		}, t))
	});
}), bs = ({ instrument: e, granularity: t, timezone: n, syncOptions: r }) => {
	let { data: i, layout: a } = e, o = a === "horizontal", s = a === "vertical", c = S(() => {
		if (s) return 0;
		let e = i.categories.length % 2 == 0;
		switch (t) {
			case "H": return "preserveStart";
			case "D":
			case "W": return e ? "preserveEnd" : "preserveStart";
			default: return "preserveStartEnd";
		}
	}, [
		i.categories.length,
		t,
		s
	]), l = {
		dataKey: "name",
		width: s ? 192 : 0,
		tickLine: { stroke: "var(--dixa-color-neutral-200)" },
		axisLine: { stroke: "var(--dixa-color-neutral-200)" },
		tickSize: 6,
		tickMargin: 8,
		interval: c,
		tick: $.tickProps,
		tickFormatter: (e) => Fo(e) ? ms(e, t, { timezone: n }) : hs(e, { length: 192 / 10 })
	}, u = {
		domain: [0, "auto"],
		allowDecimals: !1,
		tickLine: !1,
		axisLine: !1,
		tick: $.tickProps,
		ticks: r?.ticks,
		tickCount: $.tickCount,
		tickFormatter: (e) => qo(e, fs(i.formats))
	};
	return {
		xAxisProps: o ? {
			type: "category",
			...l
		} : {
			type: "number",
			...u
		},
		yAxisProps: o ? {
			type: "number",
			...u
		} : {
			type: "category",
			...l
		}
	};
}, xs = we, Ss = {
	legendItem: "_legendItem_15b15_54",
	legendItemInactive: "_legendItemInactive_15b15_61",
	legendIcon: "_legendIcon_15b15_65",
	legendIconBar: "_legendIconBar_15b15_72",
	legendIconLine: "_legendIconLine_15b15_75"
}, Cs = v(function({ instrument: e, legend: t, visualization: n, onToggleLegendItem: r, onMouseEnterLegendItem: i, onMouseLeaveLegendItem: a, hoveredLegend: o }) {
	let { series: c, options: l } = e.data, { layout: u } = l?.legend ?? { layout: "horizontal" }, d = u === "horizontal";
	return /* @__PURE__ */ E(s, {
		padding: d ? "0" : "0 0 0 400",
		flexDirection: d ? "row" : "column",
		gap: d ? "400" : "200",
		justifyContent: "center",
		children: c.map(({ label: e, options: c }, l) => {
			let u = $o(l, void 0, c?.color);
			return /* @__PURE__ */ D(s, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				className: k(Ss.legendItem, { [Ss.legendItemInactive]: o && o !== e }),
				onClick: () => r(e),
				onMouseEnter: () => i?.(e),
				onMouseLeave: () => a?.(e),
				children: [/* @__PURE__ */ E("span", {
					className: k(Ss.legendIcon, {
						[Ss.legendIconBar]: n !== "line",
						[Ss.legendIconLine]: n === "line"
					}),
					style: {
						borderColor: u,
						backgroundColor: t.includes(e) ? u : "transparent"
					}
				}), /* @__PURE__ */ E(f.Paragraph, {
					variant: "4",
					subdued: !0,
					children: e
				})]
			}, e);
		})
	});
}), ws = ({ instrument: e, visualization: t }) => {
	let { data: { series: n, options: r } } = e, i = r?.legend?.layout === "horizontal", [a, o] = j(n.filter(({ options: e }) => e?.visible ?? !0).map(({ label: e }) => e)), [s, c] = w(null);
	ee(() => {
		l();
	}, [n.length]);
	let l = y(() => {
		o.set(n.map(({ label: e }) => e));
	}, [n, o]), u = y((e) => {
		a.includes(e) && c(e);
	}, [a]), d = S(() => xs(u, 300), [u]), f = y(() => {
		d.cancel(), c(null);
	}, [d]), p = y((e) => {
		a.length === n.length ? o.filter((t) => t === e) : a.length === 1 && a.includes(e) ? l() : a.includes(e) ? o.removeAt(a.indexOf(e)) : o.push(e);
	}, [
		n.length,
		l,
		a,
		o
	]), m = S(() => n.length < 10 ? {
		onMouseEnterLegendItem: d,
		onMouseLeaveLegendItem: f,
		hoveredLegend: s
	} : {}, [
		d,
		f,
		s,
		n.length
	]);
	return {
		legend: a,
		legendProps: S(() => ({
			layout: r?.legend?.layout,
			align: i ? "center" : "right",
			verticalAlign: i ? "bottom" : "middle",
			wrapperStyle: {
				overflow: "auto",
				...i ? { bottom: 0 } : {
					right: 0,
					width: 208,
					maxHeight: "100%"
				}
			},
			content: () => /* @__PURE__ */ E(Cs, {
				visualization: t,
				instrument: e,
				legend: a,
				onToggleLegendItem: p,
				...m
			})
		}), [
			p,
			e,
			i,
			a,
			m,
			r?.legend?.layout,
			t
		]),
		hoveredLegend: s
	};
}, Ts = Te, Es = Ee, Ds = De, Os = (e) => {
	let { outerRadius: t } = e;
	return /* @__PURE__ */ D("g", { children: [/* @__PURE__ */ E(he, { ...e }), /* @__PURE__ */ E(he, {
		...e,
		innerRadius: t,
		outerRadius: t + 10,
		fillOpacity: .4
	})] });
}, ks = (e) => {
	let { name: t, value: n, cx: r, cy: i, midAngle: a, outerRadius: o, fill: s, percent: c } = e;
	if (!n || !(typeof c == "number" && c >= .01) || !(typeof r == "number" && typeof i == "number" && typeof a == "number" && typeof o == "number")) return null;
	let l = Math.PI / 180, u = o + 24, d = r + o * Math.cos(-a * l), f = i + o * Math.sin(-a * l), p = r + u * Math.cos(-a * l), m = i + u * Math.sin(-a * l), h = p + (p > r ? 12 : -12), g = m;
	return /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E("polyline", {
		points: `${d},${f} ${p},${m} ${h},${g}`,
		stroke: s,
		fill: "none",
		strokeWidth: 1
	}), /* @__PURE__ */ E("text", {
		...$.tickProps,
		fill: xe.color.secondary,
		x: h + (h > r ? 8 : -8),
		y: g,
		textAnchor: h > r ? "start" : "end",
		dominantBaseline: "middle",
		children: t
	})] });
}, As = ({ instrument: e, legend: t, hoveredLegend: n, hoveredCategory: r }) => {
	let { data: i, layout: a } = e, o = y(() => {
		let { categories: e, series: o } = i, s = o.filter(({ label: e }) => t.includes(e)), c = a === "vertical", l = c ? [
			0,
			2,
			2,
			0
		] : [
			2,
			2,
			0,
			0
		];
		return o.map(({ label: a, options: u, data: d }, f) => {
			let p = $o(f, i.options?.theme, u?.color), m = u?.stack, h = m ? s.filter((e) => e.options?.stack === m) : [], g = !m || Ts(h)?.label === a, _ = fs(i.formats), v = /* @__PURE__ */ D(T, { children: [s.length <= 10 && (!m || g) && /* @__PURE__ */ E(se, {
				position: c ? "right" : "top",
				valueAccessor: ({ payload: e }) => m ? Ds(Object.values(Es(e, h.map((e) => e.label)))) : Number(e[a] ?? 0),
				formatter: (e) => e ? qo(e, _) : "",
				...$.tickProps,
				offset: 8,
				fontSize: "var(--dixa-typography-size-100)",
				width: 0
			}), d.map((t, s) => /* @__PURE__ */ E(ae, {
				fill: o.length > 1 ? p : $o(s, i.options?.theme, e[s]?.options?.color ?? u?.color),
				fillOpacity: (r === null || r === s) && (n === null || n === a) ? 1 : .4
			}, `${a}-${s}`))] });
			return {
				key: a,
				dataKey: a,
				stackId: m,
				fill: p,
				radius: g ? l : 0,
				maxBarSize: 80,
				hide: !t.includes(a),
				children: v
			};
		});
	}, [
		i,
		r,
		n,
		a,
		t
	]), s = y(() => {
		let { series: e } = i;
		return e.map(({ label: e, options: r }, a) => ({
			key: e,
			type: "monotone",
			dot: !1,
			activeDot: { r: 5 },
			dataKey: e,
			stroke: $o(a, i.options?.theme, r?.color),
			strokeWidth: 2,
			strokeOpacity: n === null || n === e ? 1 : .4,
			connectNulls: !0,
			hide: !t.includes(e)
		}));
	}, [
		i,
		n,
		t
	]), c = y(() => {
		let { series: e } = i;
		return e.map(({ label: e, options: r }, a) => {
			let o = $o(a, i.options?.theme, r?.color), s = n === null || n === e;
			return {
				key: e,
				type: "monotone",
				dot: !1,
				activeDot: { r: 5 },
				dataKey: e,
				stackId: r?.stack,
				stroke: o,
				strokeWidth: 2,
				fill: o,
				fillOpacity: s ? .9 : .2,
				strokeOpacity: +!!s,
				connectNulls: !0,
				hide: !t.includes(e)
			};
		});
	}, [
		i,
		n,
		t
	]), l = y((e) => {
		let { categories: t, series: n } = i, r = t.map(({ label: e, options: t }, n) => /* @__PURE__ */ E(ae, {
			fill: $o(n, i.options?.theme, t?.color),
			style: { outline: "none" }
		}, e));
		return {
			dataKey: n[0]?.label,
			cx: "50%",
			cy: "50%",
			label: ks,
			labelLine: !1,
			activeShape: Os,
			inactiveShape: { fillOpacity: .4 },
			stroke: be.neutral["000"],
			strokeWidth: 1.5,
			innerRadius: e === "donut" ? "50%" : 0,
			outerRadius: "80%",
			startAngle: 90,
			endAngle: -270,
			children: r
		};
	}, [i]);
	return { getSeriesProps: y((e) => {
		switch (e) {
			case "bar": return o();
			case "line": return s();
			case "area": return c();
			case "pie":
			case "donut": return l(e);
			default: return [];
		}
		return [];
	}, [
		c,
		o,
		s,
		l
	]) };
}, js = v(function({ instrument: e, panel: t, timezone: n, syncOptions: r, onChangeGranularity: i, onChangeVisualization: a, onChangeFormat: c }) {
	let [l, u] = w(t.controls?.settings.visualization ?? e.visualization), [d, p] = w(null), { data: m, layout: g, title: _ } = e, v = g === "horizontal", b = g === "vertical", x = S(() => us(m, { omitZero: l === "bar" }), [m, l]), C = S(() => m.granularities?.find(({ selected: e }) => e)?.value, [m.granularities]), O = S(() => {
		if (!m.options?.visualizations) return [];
		let e = ["bar"], t = m.series.length === 1;
		return m.categories.every(({ label: e }) => Fo(e)) ? e.push("line", "area") : t && e.push("pie", "donut"), e;
	}, [
		m.categories,
		m.options?.visualizations,
		m.series.length
	]), { xAxisProps: k, yAxisProps: A } = bs({
		instrument: e,
		granularity: C,
		timezone: n,
		syncOptions: r
	}), { legend: j, legendProps: M, hoveredLegend: N } = ws({
		instrument: e,
		visualization: l
	}), { getSeriesProps: ae } = As({
		instrument: e,
		legend: j,
		hoveredLegend: N,
		hoveredCategory: d
	});
	ee(() => {
		u(t.controls?.settings.visualization ?? e.visualization);
	}, [t.controls?.settings.visualization, e.visualization]);
	let se = y((e) => {
		u(e), a?.(e);
	}, [a]), he = (e) => {
		if (!e?.isTooltipActive) {
			p(null);
			return;
		}
		let t = e.activeTooltipIndex;
		if (typeof t != "number") return;
		let n = Object.values(x[t] ?? {}).length > 1;
		p(n ? t : null);
	}, ye = () => {
		p(null);
	}, be = () => l === "line" ? ae(l).map(({ key: e, ...t }) => /* @__PURE__ */ E(le, { ...t }, e)) : l === "bar" ? ae(l).map(({ key: e, ...t }) => /* @__PURE__ */ E(ne, { ...t }, e)) : l === "area" ? ae(l).map(({ key: e, ...t }) => /* @__PURE__ */ E(te, { ...t }, e)) : l === "pie" || l === "donut" ? /* @__PURE__ */ E(de, {
		data: x,
		...ae(l)
	}) : null, xe = () => {
		let i = m.options?.legend?.layout, a = {
			layout: g,
			syncId: r?.tooltip ? t.id : void 0,
			data: x,
			margin: {
				top: v ? 16 : 0,
				right: b || i === "vertical" ? 16 : 0,
				bottom: i === "horizontal" ? 16 / 2 : 0,
				left: 0
			}
		}, o = l === "bar" || l === "line" || l === "area", s = /* @__PURE__ */ D(T, { children: [
			o && /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E(_e, { ...k }), /* @__PURE__ */ E(ve, { ...A })] }),
			o && m.options?.cartesian && /* @__PURE__ */ E(ie, {
				vertical: b,
				horizontal: v,
				stroke: "var(--dixa-color-neutral-200)"
			}),
			o && m.references?.map(({ value: e, label: t }, n) => /* @__PURE__ */ E(pe, {
				...v ? { y: e } : { x: e },
				stroke: "var(--dixa-color-neutral-500)",
				strokeDasharray: "5 5",
				isFront: !0,
				children: /* @__PURE__ */ E(oe, {
					value: t,
					offset: 8,
					fontSize: "var(--dixa-typography-size-200)",
					position: v ? "insideBottomLeft" : "insideTopLeft"
				})
			}, n)),
			m.options?.legend && /* @__PURE__ */ E(ce, { ...M }),
			m.options?.tooltip && /* @__PURE__ */ E(ge, {
				content: (t) => /* @__PURE__ */ E(_s, {
					instrument: e,
					granularity: C,
					timezone: n,
					tooltipProps: t
				}),
				cursor: { fill: "transparent" }
			}),
			be()
		] });
		switch (l) {
			case "bar": return /* @__PURE__ */ E(re, {
				...a,
				barGap: "1",
				onMouseMove: he,
				onMouseLeave: ye,
				children: s
			});
			case "line": return /* @__PURE__ */ E(ue, {
				...a,
				children: s
			});
			case "area": return /* @__PURE__ */ E(P, {
				...a,
				children: s
			});
			case "pie":
			case "donut": return /* @__PURE__ */ E(fe, {
				...a,
				children: s
			});
		}
	};
	if (!m.categories.length || !m.series.length) return /* @__PURE__ */ E(s, {
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		children: /* @__PURE__ */ E(o, {
			title: "No data available",
			description: "There is no data available for the selected period and filters.",
			icon: $.visualizationIcons[l]
		})
	});
	let Se = [
		m.formats && m.formats.length > 1 ? /* @__PURE__ */ E(ts, {
			formats: m.formats,
			onChangeFormat: c
		}, "format") : null,
		m.granularities && m.granularities.length > 1 ? /* @__PURE__ */ E(ns, {
			granularities: m.granularities,
			onChangeGranularity: i
		}, "granularity") : null,
		m.options?.visualizations ? /* @__PURE__ */ E(ys, {
			visualization: l,
			visualizations: O,
			onChangeVisualization: se
		}, "visualization") : null
	], Ce = Se.some(Boolean);
	return /* @__PURE__ */ D(T, { children: [
		_ && /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(f.Heading, {
			variant: "heading-4",
			children: _
		}) }),
		Ce && /* @__PURE__ */ E(s, {
			alignSelf: "flex-end",
			gap: "300",
			children: Se.map((e, t) => /* @__PURE__ */ E(h, { children: e }, t))
		}),
		/* @__PURE__ */ E(me, {
			className: es.container,
			width: "100%",
			height: "100%",
			debounce: 100,
			children: xe()
		})
	] });
}), Ms = Oe, Ns = ke, Ps = { trigger: "_trigger_1mrk9_1" }, Fs = v(function({ title: e, metrics: t, children: n }) {
	return /* @__PURE__ */ E(p, {
		content: /* @__PURE__ */ D(s, {
			flexDirection: "column",
			gap: "200",
			children: [/* @__PURE__ */ E(f.Paragraph, {
				variant: "1",
				color: "inherit",
				children: e
			}), t.length > 0 && /* @__PURE__ */ E(is, {
				bounded: !0,
				children: t.map((e, t) => /* @__PURE__ */ E(ls, {
					instrument: e,
					theme: "dark"
				}, t))
			})]
		}),
		wrap: "div",
		wrapProps: { className: Ps.trigger },
		children: n
	});
}), Is = {
	cell: "_cell_hfkay_1",
	cellText: "_cellText_hfkay_11",
	cellDimmed: "_cellDimmed_hfkay_14",
	cellContent: "_cellContent_hfkay_18"
}, Ls = v(function({ cell: e, dimmed: t = !1, background: n = "transparent", tooltipProps: r, textProps: i = {}, onMouseEnter: a }) {
	let [o, s] = w(!1), c = N(e?.value);
	ee(() => {
		if (e?.value !== c) {
			s(!0);
			let e = setTimeout(() => {
				s(!1);
			}, 200);
			return () => {
				clearTimeout(e);
			};
		}
	}, [e?.value]);
	let l = S(() => {
		if (!e) return null;
		let { value: t, format: n } = e;
		return typeof t == "string" ? t : typeof t == "number" && n ? qo(t, n) : "—";
	}, [e]);
	if (!e) return /* @__PURE__ */ E("div", {
		className: Is.cell,
		onMouseEnter: a,
		"data-testid": "heatmap-instrument-cell"
	});
	let u = /* @__PURE__ */ E("div", {
		className: Is.cellContent,
		children: /* @__PURE__ */ E(f.Paragraph, {
			className: k({ [Is.cellText]: typeof e.value == "string" }),
			variant: "3",
			subdued: !Ns(e.value),
			...i,
			children: l
		})
	});
	return /* @__PURE__ */ E("div", {
		className: k(Is.cell, { [Is.cellDimmed]: t || o }),
		onMouseEnter: a,
		style: { backgroundColor: n },
		"data-animating": o,
		"data-testid": "heatmap-instrument-cell",
		children: r?.enabled ? /* @__PURE__ */ E(Fs, {
			...r,
			children: u
		}) : u
	});
}), Rs = {
	grid: "_grid_1qk2p_1",
	row: "_row_1qk2p_7"
}, zs = Number.isNaN || function(e) {
	return typeof e == "number" && e !== e;
};
function Bs(e, t) {
	return !!(e === t || zs(e) && zs(t));
}
function Vs(e, t) {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) if (!Bs(e[n], t[n])) return !1;
	return !0;
}
function Hs(e, t) {
	t === void 0 && (t = Vs);
	var n = null;
	function r() {
		var r = [...arguments];
		if (n && n.lastThis === this && t(r, n.lastArgs)) return n.lastResult;
		var i = e.apply(this, r);
		return n = {
			lastResult: i,
			lastArgs: r,
			lastThis: this
		}, i;
	}
	return r.clear = function() {
		n = null;
	}, r;
}
//#endregion
//#region src/components/instruments/heatmapInstrument/utils/heatmapTheming.ts
var Us = [
	"100",
	"200",
	"400",
	"500",
	"700"
].map((e) => `var(--dixa-color-purple-${e})`), Ws = Hs((e) => {
	if (e === null) return {
		backgroundColor: "var(--dixa-color-neutral-000)",
		color: "tertiary"
	};
	let t = Math.min(4, Math.floor(5 / 100 * Math.min(e, 100)));
	return {
		backgroundColor: Us?.[t] ?? "var(--dixa-color-neutral-000)",
		color: t >= 3 ? "white" : "primary"
	};
});
function Gs(e) {
	return typeof e == "number" && !Number.isNaN(e) && e >= 0;
}
var Ks = (e) => {
	let t = e.flatMap(({ data: e }) => e.map((e) => ds(e).value)).filter(Gs);
	return {
		min: Math.min(...t),
		max: Math.max(...t)
	};
}, qs = (e, { min: t, max: n }) => t === n ? 100 : Math.round(100 * (e - t) / (n - t)), Js = ({ instrument: e }) => {
	let { data: { categories: t, series: n } } = e, r = C(null), [i, a] = M({
		cell: null,
		column: null,
		row: null
	}), o = S(() => Object.values(i).some((e) => e !== null), [i]), s = S(() => Ks(n), [n]);
	x(() => {
		let e = (e) => {
			r.current && !r.current.contains(e.target) && o && a.reset();
		};
		return window.addEventListener("mousemove", e, !0), () => {
			window.removeEventListener("mousemove", e, !0);
		};
	}, [o, a]);
	let c = y((e) => {
		if (!o) return !1;
		let [t, n] = e;
		return i.cell ? !Ms(i.cell.id, e) : i.column === null ? i.row !== null && i.row !== t : i.column !== n;
	}, [
		o,
		i.cell,
		i.column,
		i.row
	]), l = y((e) => a.setAll({
		cell: null,
		column: e,
		row: null
	}), [a]), u = y((e) => a.setAll({
		cell: null,
		column: null,
		row: e
	}), [a]), d = y((e) => {
		(o || e !== null) && a.setAll({
			cell: e,
			column: null,
			row: null
		});
	}, [o, a]), f = y(() => {
		o && a.reset();
	}, [o, a]);
	return /* @__PURE__ */ D("div", {
		ref: r,
		className: Rs.grid,
		onMouseLeave: () => a.reset(),
		"data-testid": "heatmap-instrument",
		children: [/* @__PURE__ */ D("div", {
			className: Rs.row,
			children: [/* @__PURE__ */ E(Ls, { onMouseEnter: f }), n.map((e, t) => {
				let r = n[t].metrics ?? [];
				return /* @__PURE__ */ E(Ls, {
					cell: {
						id: [0, t],
						value: e.label
					},
					tooltipProps: {
						enabled: r.length > 0,
						title: e.label,
						metrics: r
					},
					onMouseEnter: () => l(t)
				}, e.label);
			})]
		}), t.map((r, i) => {
			let a = t[i].metrics ?? [];
			return /* @__PURE__ */ D("div", {
				className: Rs.row,
				children: [/* @__PURE__ */ E(Ls, {
					cell: {
						id: [i, 0],
						value: r.label
					},
					tooltipProps: {
						enabled: a.length > 0,
						title: r.label,
						metrics: a
					},
					onMouseEnter: () => u(i)
				}), n.map((t, n) => {
					let a = [i, n], { value: o, metrics: l } = ds(t.data[i]), u = fs(e.data.formats), f = Ns(o), { backgroundColor: p, color: m } = Ws(f ? qs(o, s) : null);
					return /* @__PURE__ */ E(Ls, {
						cell: {
							id: a,
							value: o,
							format: u
						},
						dimmed: c(a),
						background: p,
						tooltipProps: {
							enabled: f,
							title: `${r.label}, ${t.label}`,
							metrics: l?.length ? l : [{
								type: "metric",
								title: "Total",
								data: o,
								format: u === "count" ? "number" : u
							}]
						},
						textProps: { color: m },
						onMouseEnter: () => d(f ? {
							id: a,
							value: o
						} : null)
					}, a.join(","));
				})]
			}, r.label);
		})]
	});
}, Ys = {
	legend: "_legend_1k9xu_54",
	trigger: "_trigger_1k9xu_58",
	popover: "_popover_1k9xu_64",
	breakdown: "_breakdown_1k9xu_83"
}, Xs = v(function({ instrument: e }) {
	let { data: { availability: n, media_type: r, away: i } } = e, o = ["var(--dixa-color-purple-700)", "var(--dixa-color-neutral-200)"], c = "No data available", u = {
		labelWidth: Math.max(...r.map((e) => e.label.length)) * 7,
		theme: o
	}, d = () => /* @__PURE__ */ E(No, {
		...u,
		value: 0,
		label: "n.a.",
		theme: ["var(--dixa-color-neutral-200)", "var(--dixa-color-neutral-200)"],
		showFullBar: !0
	});
	return /* @__PURE__ */ D(s, {
		flexDirection: "column",
		gap: "400",
		children: [/* @__PURE__ */ D(s, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				subdued: !0,
				children: n.length ? "Availability" : c
			}), n.length ? /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ D(s, {
				gap: "300",
				className: Ys.legend,
				children: [n.map((e, n) => /* @__PURE__ */ D(s, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ E(t, {
						width: "6px",
						height: "6px",
						background: o[n],
						borderRadius: "50%"
					}), /* @__PURE__ */ E(f.Paragraph, {
						variant: "4",
						children: e.label
					})]
				}, n)), (() => {
					if (!i || !i.length) return null;
					let [e, t, ...n] = i;
					return /* @__PURE__ */ D(bo, { children: [/* @__PURE__ */ E(xo, {
						asChild: !0,
						children: /* @__PURE__ */ E(l, {
							variant: "tertiary",
							icon: "dots-h",
							className: Ys.trigger
						})
					}), /* @__PURE__ */ E(So, { children: /* @__PURE__ */ E(Co, {
						side: "right",
						className: Ys.popover,
						children: /* @__PURE__ */ D("ul", {
							className: Ys.breakdown,
							children: [
								/* @__PURE__ */ D("li", { children: [/* @__PURE__ */ E(f.Paragraph, {
									variant: "1",
									children: e.label
								}), /* @__PURE__ */ E(f.Paragraph, {
									variant: "1",
									children: Po(e.value)
								})] }),
								/* @__PURE__ */ D("li", { children: [/* @__PURE__ */ E(f.Paragraph, {
									variant: "2",
									subdued: !0,
									children: t.label
								}), /* @__PURE__ */ E(f.Paragraph, {
									variant: "2",
									subdued: !0,
									children: Po(t.value)
								})] }),
								/* @__PURE__ */ E(a, {}),
								n.map((e, t) => /* @__PURE__ */ D("li", { children: [/* @__PURE__ */ E(f.Paragraph, {
									variant: "2",
									children: e.label
								}), /* @__PURE__ */ E(f.Paragraph, {
									variant: "1",
									children: Po(e.value)
								})] }, t))
							]
						})
					}) })] });
				})()]
			}), /* @__PURE__ */ E(No, {
				...u,
				value: n[0].value,
				label: "Total",
				showFullBar: !0,
				showDifference: !0
			})] }) : d()]
		}), /* @__PURE__ */ D(s, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ E(f.Paragraph, {
				variant: "4",
				subdued: !0,
				children: r.length ? "Availability per channel" : c
			}), r.length > 0 ? /* @__PURE__ */ E(s, {
				flexDirection: "column",
				gap: "200",
				children: r.map((e, t) => /* @__PURE__ */ _(No, {
					...u,
					key: t,
					value: e.value,
					label: e.label
				}))
			}) : d()]
		})]
	});
}), Zs = {
	tooltip: "_tooltip_h4i5v_1",
	trigger: "_trigger_h4i5v_5"
}, Qs = ({ text: e }) => /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E("span", { children: e }), /* @__PURE__ */ E(p, {
	className: Zs.tooltip,
	content: e,
	wrap: "div",
	wrapProps: { className: Zs.trigger }
})] }), $s = v(function({ value: e }) {
	let [t, ...n] = e;
	return /* @__PURE__ */ D(s, {
		gap: "200",
		alignItems: "center",
		children: [/* @__PURE__ */ E(f.Paragraph, {
			variant: "2",
			as: "span",
			children: t
		}), n.length > 0 && /* @__PURE__ */ E(p, {
			content: n.join(", "),
			children: /* @__PURE__ */ D(f.ExternalLink, {
				as: "span",
				children: [
					"+ ",
					n.length,
					" more"
				]
			})
		})]
	});
}), ec = ({ cell: t, format: n, timezone: r, customFormats: i }) => {
	let a = S(() => {
		if (!t || tc(t.value)) return /* @__PURE__ */ E(f.Paragraph, {
			variant: "2",
			color: "neutral.500",
			children: "n.a."
		});
		let { value: e, label: a } = t;
		if (a) return a;
		if (i?.[n]) return i[n]?.({ value: e });
		switch (n) {
			case "boolean": return e ? "Y" : "N";
			case "date": return ye.tz(e, r).format("L, LT");
			case "count": return Ro(e);
			case "number": return zo(e);
			case "percentage": return `${zo(e)}%`;
			case "duration": return Po(e);
			case "csid": return `#${e}`;
			case "rating": return `${e}`;
			case "presence": return /* @__PURE__ */ E(No, {
				value: e,
				showFullBar: !0
			});
			case "tags": return /* @__PURE__ */ E(Ae, {
				tags: e,
				limit: 1
			});
			case "text": return /* @__PURE__ */ E(Qs, { text: e });
			case "list": return /* @__PURE__ */ E($s, { value: e });
			default: return `${e}`;
		}
	}, [
		t,
		i,
		n,
		r
	]);
	return t?.ui?.type === "badge" ? /* @__PURE__ */ E(e, {
		variant: t.ui.variant,
		size: "medium",
		children: /* @__PURE__ */ E(T, { children: a })
	}) : /* @__PURE__ */ E(T, { children: a });
};
function tc(e) {
	let t = e === null, n = typeof e == "string" && e.trim() === "", r = Array.isArray(e) && !e.length;
	return t || n || r;
}
var nc = {
	tableWrapper: "_tableWrapper_1xmkm_1",
	tableWrapperEmpty: "_tableWrapperEmpty_1xmkm_4",
	thCell: "_thCell_1xmkm_8",
	tdCell: "_tdCell_1xmkm_12",
	tooltip: "_tooltip_1xmkm_20"
}, rc = je, ic = Me, ac = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", oc = (e, t) => {
	let n = e.cells.find((e) => e.column === t.key);
	return !n || n.value === null ? null : (n.value, n.value);
}, sc = ({ data: { columns: e, rows: t }, limit: n = 50, sortStatus: r }) => {
	let i = Math.ceil(t.length / n), [a, o] = w(1);
	ee(() => {
		a !== 1 && o(1);
	}, [r, i]);
	let s = S(() => {
		if (!r) return t;
		let n = e.find(({ key: e }) => e === r.sortBy);
		return n ? ic(t, [(e) => !rc(oc(e, n)), (e) => oc(e, n)], ["desc", r.direction]) : t;
	}, [
		e,
		t,
		r
	]);
	return {
		rows: S(() => s.slice((a - 1) * n, a * n), [
			a,
			n,
			s
		]),
		currentPage: a,
		totalPages: i,
		setPage: o
	};
}, cc = ({ instrument: e, timezone: t, onReadInstruments: r, onLoadAll: i, onSortChange: a, customFormats: l }) => {
	let { title: p, data: m, data: { columns: h, options: g } } = e, [_, v] = w(null), b = C(null), x = g?.limit ?? 50, { rows: S, currentPage: O, totalPages: A, setPage: j } = sc({
		data: m,
		limit: x,
		sortStatus: _
	}), M = m.rows.length === 0, N = !!g?.next_page, te = !N && A > 1;
	ee(() => {
		b.current && (b.current.scrollTop = 0);
	}, [O]);
	let P = y(() => (i?.(), r({ meta: { pagination: { limit: null } } })), [i, r]), ne = y(async (e) => {
		N && await P(), v(e), a?.(e);
	}, [
		P,
		a,
		N
	]);
	return /* @__PURE__ */ D(T, { children: [p && /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(f.Heading, {
		variant: "heading-4",
		children: p
	}) }), /* @__PURE__ */ D(d, {
		stickyHeader: !0,
		sortingProps: {
			sortStatus: _,
			onSortChange: ne
		},
		wrapperProps: { className: k(nc.tableWrapper, { [nc.tableWrapperEmpty]: M }) },
		wrapperRef: b,
		hoverable: !M,
		children: [
			/* @__PURE__ */ E(d.Thead, { children: /* @__PURE__ */ E(d.Tr, { children: h.map(({ key: e, label: t, sortable: n }) => /* @__PURE__ */ E(d.Th, {
				className: nc.thCell,
				columnId: n ? e : null,
				children: t
			}, e)) }) }),
			/* @__PURE__ */ D(d.Tbody, { children: [M && /* @__PURE__ */ E(d.Tr, { children: /* @__PURE__ */ E(d.Td, {
				colSpan: h.length,
				children: /* @__PURE__ */ E(o, {
					title: "No data available",
					description: "There is no data available for the selected period and filters.",
					icon: "th"
				})
			}) }), S.map((e, n) => {
				let r = `row-${n}`;
				return /* @__PURE__ */ E(d.Tr, { children: h.map(({ key: n, format: i }, a) => {
					let o = e.cells.find((e) => e.column === n);
					return /* @__PURE__ */ E(d.Td, {
						className: nc.tdCell,
						children: /* @__PURE__ */ E(ec, {
							cell: o,
							format: i,
							timezone: t,
							customFormats: l
						})
					}, `${r}-cell-${a}`);
				}) }, r);
			})] }),
			N && /* @__PURE__ */ E(d.Footer, { children: /* @__PURE__ */ D(s, {
				alignItems: "center",
				justifyContent: "center",
				gap: "300",
				children: [/* @__PURE__ */ D(s, {
					gap: "100",
					alignItems: "center",
					children: [/* @__PURE__ */ E(c, {
						tooltipClassName: nc.tooltip,
						text: `By default we only load the first ${x} results. If you need to see all available results, click on the button, but beware that this may take a bit of time to load depending on the number of results.`
					}), /* @__PURE__ */ D(f.Paragraph, {
						variant: "2",
						children: ["Showing only the ", /* @__PURE__ */ D("b", { children: [
							"first ",
							x,
							" results"
						] })]
					})]
				}), /* @__PURE__ */ E(n, {
					variant: "secondary",
					onClick: P,
					children: "Load all results"
				})]
			}) }),
			te && /* @__PURE__ */ E(d.Footer, { children: /* @__PURE__ */ E(s, {
				alignItems: "center",
				justifyContent: "center",
				children: /* @__PURE__ */ E(u, {
					pageCount: A,
					currentPage: O,
					pageRangeDisplayed: 6,
					onPageChange: j
				})
			}) })
		]
	})] });
};
//#endregion
export { To as AnalyticsMenu, js as ChartInstrument, Js as HeatmapInstrument, ls as MetricInstrument, ss as MetricInstrumentData, is as MetricInstrumentsGrid, No as PercentageBar, Xs as PresenceInstrument, cc as TableInstrument, Bo as categorizeInstruments, $ as chartAppearance, Ro as formatAbbreviateNumber, qo as formatInstrumentNumber, zo as formatLocalizedNumber, Po as formatMillisecondsToDuration, fs as getChartSeriesFormat, ds as getChartSeriesValue, Ko as isAIInsightInstrument, Ho as isChartInstrument, Fo as isDateLikeString, Uo as isHeatmapInstrument, Vo as isMetricInstrument, Go as isPresenceInstrument, Wo as isTableInstrument, ac as isTableInstrumentDataValuePrimitive, $o as resolveChartElementColor, Qo as resolveInstrumentColor };

//# sourceMappingURL=index.js.map